/* CANFOTO — E1-K2-F01C
   REV85 PDP OWNER CONSOLIDATION / ARCHITECTURE LOCK R1
   Single active responsive presentation/semantic adapter.
   Native Shopify cart/variant/checkout truth remains owner. */
(() => {
  'use strict';
  const VERSION='CANFOTO-E1-K2-F01C-REV85-PDP-OWNER-CONSOLIDATED-R1';
  if(window.__CANFOTO_E1_K2_F01C_REV85_OWNER__) return;
  window.__CANFOTO_E1_K2_F01C_REV85_OWNER__=true;
  window.CANFOTO_E1_F10_R5_PDP_VISIBLE_CLOSURE='CUSTOMER_COPY_CTA_SEMANTIC_R1';
  window.CANFOTO_E1_F10_R6_PDP_PHYSICAL_CALIBRATION='DESKTOP_HERO_PRICE_TEXT_FAIL_CLOSED_R1';
  window.CANFOTO_E1_F10_R9_PDP_COMPACT_INFO_CAMPAIGN='RESPONSIVE_INFO_CAMPAIGN_COMPACT_R1';
  window.CANFOTO_E1_F10_R91_PDP_COMMERCIAL_COMPACT='CAMPAIGN_PRICE_INFO_STABILIZED_R1';
  window.CANFOTO_E1_F10_R14_RELATED_RECENT_COMMERCE='NATIVE_QUICKADD_9STYLE_R1';
  window.CANFOTO_E1_F10_R14B_V54_CARD_ARCHITECTURE='SUPERSEDED_BY_R14C_COLLECTION_CARD_PARITY';
  window.CANFOTO_E1_F10_R14C_UNIFIED_PRODUCT_CARD='COLLECTION_POOL_PARITY_9STYLE_R1';

  const PANEL={"gdx-p300ts-bicolor-fotografcilik-ve-studyo-aydinlatmasi-80-watt-led-video-panel-surekli-isik":{"family":"bicolor","wattBand":"mid","channelArchitecture":"BI_COLOR_CCT","nominalPowerW":80,"effectiveWhitePowerW":78,"effectiveCreativePowerW":18,"whiteRoleLabel":"Beyaz/CCT key-fill ışık","creativeRoleLabel":"Beyaz destek ışığı; RGB/FX ana avantaj sınırlı","kelvinLabel":"2.700K–7.500K","top5Purposes":["Klinik / Estetik / Dental · Cilt / yüz çekimi","Klinik / Estetik / Dental · Dental / ağız içi destek","Klinik / Estetik / Dental · Klinik sosyal medya içerikleri","YouTube / Reels / Sosyal Medya · Tek kişi video","Röportaj / Konuşan Kafa · Tek kişi röportaj"],"top5Count":5},"gdx-pro-led-gx-300-soft-light-bataryali-led-isik":{"family":"bicolor","wattBand":"mid","channelArchitecture":"BI_COLOR_CCT","nominalPowerW":65,"effectiveWhitePowerW":64,"effectiveCreativePowerW":14,"whiteRoleLabel":"Yakın mesafe fill / destek ışığı","creativeRoleLabel":"Beyaz destek ışığı; RGB/FX ana avantaj sınırlı","kelvinLabel":"","top5Purposes":["Mobil / Dış Mekan · Taşınabilir ekip","Mobil / Dış Mekan · Bataryalı çekim","Mobil / Dış Mekan · Mekan içi hızlı kurulum","Klinik / Estetik / Dental · Dental / ağız içi destek","Klinik / Estetik / Dental · Cilt / yüz çekimi"],"top5Count":5},"gdx-cf-led-200w-video-led-isik":{"family":"bicolor","wattBand":"pro","channelArchitecture":"BI_COLOR_CCT","nominalPowerW":200,"effectiveWhitePowerW":196,"effectiveCreativePowerW":44,"whiteRoleLabel":"Beyaz/CCT ana key ışık","creativeRoleLabel":"Beyaz destek ışığı; RGB/FX ana avantaj sınırlı","kelvinLabel":"3.200K–5.600K","top5Purposes":["Ürün Çekimi / E-Ticaret · Büyük ürün / model üzerinde çekim","Ürün Çekimi / E-Ticaret · Pazar yeri / katalog çekimi","Klinik / Estetik / Dental · Cilt / yüz çekimi","Klinik / Estetik / Dental · Dental / ağız içi destek","Stüdyo / Profesyonel Çekim · Model çekimi"],"top5Count":5},"gdx-cf-led-120w-video-led-isik":{"family":"bicolor","wattBand":"high","channelArchitecture":"BI_COLOR_CCT","nominalPowerW":120,"effectiveWhitePowerW":118,"effectiveCreativePowerW":26,"whiteRoleLabel":"Beyaz/CCT ana key ışık","creativeRoleLabel":"Beyaz destek ışığı; RGB/FX ana avantaj sınırlı","kelvinLabel":"3.200K–5.600K","top5Purposes":["Klinik / Estetik / Dental · Cilt / yüz çekimi","Klinik / Estetik / Dental · Dental / ağız içi destek","Ürün Çekimi / E-Ticaret · Pazar yeri / katalog çekimi","YouTube / Reels / Sosyal Medya · Tek kişi video","Röportaj / Konuşan Kafa · Tek kişi röportaj"],"top5Count":5},"gdx-pro-led-228as-bataryali-surekli-led-isik":{"family":"bicolor","wattBand":"low","channelArchitecture":"BI_COLOR_CCT","nominalPowerW":20,"effectiveWhitePowerW":20,"effectiveCreativePowerW":4,"whiteRoleLabel":"Yakın mesafe fill / destek ışığı","creativeRoleLabel":"Beyaz destek ışığı; RGB/FX ana avantaj sınırlı","kelvinLabel":"3.200K–6.000K","top5Purposes":["Klinik / Estetik / Dental · Cilt / yüz çekimi","Klinik / Estetik / Dental · Dental / ağız içi destek","Mobil / Dış Mekan · Taşınabilir ekip","Mobil / Dış Mekan · Bataryalı çekim","Klinik / Estetik / Dental · Klinik sosyal medya içerikleri"],"top5Count":5},"godox-ldx50r-rgbww-profesyonel-led-panel-aydinlatma":{"family":"rgb","wattBand":"unknown","channelArchitecture":"RGBWW","nominalPowerW":63,"effectiveWhitePowerW":54,"effectiveCreativePowerW":63,"whiteRoleLabel":"Yakın mesafe fill / destek ışığı","creativeRoleLabel":"RGB accent / fon / atmosfer ışığı","kelvinLabel":"2.500K–10.000K","top5Purposes":["RGB / Kreatif Video · Arka plan renk efekti","Mobil / Dış Mekan · Bataryalı çekim","Mobil / Dış Mekan · Taşınabilir ekip","Mobil / Dış Mekan · Mekan içi hızlı kurulum","RGB / Kreatif Video · Ürün arkasında renk ayrımı"],"top5Count":5},"gdx-p-750c-ii-bicolor-canli-yayin-ve-roportaj-isik-kaynagi":{"family":"bicolor","wattBand":"pro","channelArchitecture":"BI_COLOR_CCT","nominalPowerW":250,"effectiveWhitePowerW":245,"effectiveCreativePowerW":55,"whiteRoleLabel":"Beyaz/CCT ana key ışık","creativeRoleLabel":"Beyaz destek ışığı; RGB/FX ana avantaj sınırlı","kelvinLabel":"2.700K–6.500K","top5Purposes":["Ürün Çekimi / E-Ticaret · Büyük ürün / model üzerinde çekim","Ürün Çekimi / E-Ticaret · Pazar yeri / katalog çekimi","Ürün Çekimi / E-Ticaret · Küçük ürün / masaüstü çekim","Stüdyo / Profesyonel Çekim · Model çekimi","Klinik / Estetik / Dental · Cilt / yüz çekimi"],"top5Count":5},"gdx-cf-300c-bicolor-led-video-isigi":{"family":"bicolor","wattBand":"low","channelArchitecture":"BI_COLOR_CCT","nominalPowerW":30,"effectiveWhitePowerW":29,"effectiveCreativePowerW":7,"whiteRoleLabel":"Yakın mesafe fill / destek ışığı","creativeRoleLabel":"Beyaz destek ışığı; RGB/FX ana avantaj sınırlı","kelvinLabel":"3.200K–5.600K","top5Purposes":["Klinik / Estetik / Dental · Cilt / yüz çekimi","Klinik / Estetik / Dental · Dental / ağız içi destek","Mobil / Dış Mekan · Taşınabilir ekip","Mobil / Dış Mekan · Bataryalı çekim","Klinik / Estetik / Dental · Klinik sosyal medya içerikleri"],"top5Count":5},"gdx-cf-led-900w-video-led-isigi":{"family":"bicolor","wattBand":"pro","channelArchitecture":"BI_COLOR_CCT","nominalPowerW":100,"effectiveWhitePowerW":98,"effectiveCreativePowerW":22,"whiteRoleLabel":"Beyaz/CCT key-fill ışık","creativeRoleLabel":"Beyaz destek ışığı; RGB/FX ana avantaj sınırlı","kelvinLabel":"3.200K–5.600K","top5Purposes":["Klinik / Estetik / Dental · Cilt / yüz çekimi","Klinik / Estetik / Dental · Dental / ağız içi destek","Röportaj / Konuşan Kafa · Tek kişi röportaj","Klinik / Estetik / Dental · Klinik sosyal medya içerikleri","Röportaj / Konuşan Kafa · İki kişi röportaj"],"top5Count":5},"godox-p260c-pro-bi-color-panel-led-video-isigi":{"family":"bicolor","wattBand":"low","channelArchitecture":"BI_COLOR_CCT","nominalPowerW":45,"effectiveWhitePowerW":44,"effectiveCreativePowerW":10,"whiteRoleLabel":"Yakın mesafe fill / destek ışığı","creativeRoleLabel":"Beyaz destek ışığı; RGB/FX ana avantaj sınırlı","kelvinLabel":"2.800K–6.500K","top5Purposes":["Klinik / Estetik / Dental · Cilt / yüz çekimi","Klinik / Estetik / Dental · Dental / ağız içi destek","Mobil / Dış Mekan · Taşınabilir ekip","Mobil / Dış Mekan · Bataryalı çekim","Mobil / Dış Mekan · Mekan içi hızlı kurulum"],"top5Count":5},"gdx-cf-led-1024w-video-led-isik":{"family":"bicolor","wattBand":"pro","channelArchitecture":"BI_COLOR_CCT","nominalPowerW":60,"effectiveWhitePowerW":59,"effectiveCreativePowerW":13,"whiteRoleLabel":"Yakın mesafe fill / destek ışığı","creativeRoleLabel":"Beyaz destek ışığı; RGB/FX ana avantaj sınırlı","kelvinLabel":"5.600K","top5Purposes":["Klinik / Estetik / Dental · Cilt / yüz çekimi","Klinik / Estetik / Dental · Dental / ağız içi destek","Mobil / Dış Mekan · Mekan içi hızlı kurulum","Mobil / Dış Mekan · Taşınabilir ekip","Klinik / Estetik / Dental · Klinik sosyal medya içerikleri"],"top5Count":5},"gdx-cf-led-1700w-video-led-isigi":{"family":"bicolor","wattBand":"pro","channelArchitecture":"BI_COLOR_CCT","nominalPowerW":150,"effectiveWhitePowerW":147,"effectiveCreativePowerW":33,"whiteRoleLabel":"Beyaz/CCT ana key ışık","creativeRoleLabel":"Beyaz destek ışığı; RGB/FX ana avantaj sınırlı","kelvinLabel":"3.200K–5.600K","top5Purposes":["Ürün Çekimi / E-Ticaret · Büyük ürün / model üzerinde çekim","Klinik / Estetik / Dental · Cilt / yüz çekimi","Klinik / Estetik / Dental · Dental / ağız içi destek","Ürün Çekimi / E-Ticaret · Pazar yeri / katalog çekimi","Mobil / Dış Mekan · Taşınabilir ekip"],"top5Count":5},"gdx-cf-led-2020c-video-led-isik":{"family":"bicolor","wattBand":"high","channelArchitecture":"BI_COLOR_CCT","nominalPowerW":120,"effectiveWhitePowerW":118,"effectiveCreativePowerW":26,"whiteRoleLabel":"Beyaz/CCT ana key ışık","creativeRoleLabel":"Beyaz destek ışığı; RGB/FX ana avantaj sınırlı","kelvinLabel":"3.200K–5.600K","top5Purposes":["Klinik / Estetik / Dental · Dental / ağız içi destek","Klinik / Estetik / Dental · Cilt / yüz çekimi","Mobil / Dış Mekan · Mekan içi hızlı kurulum","Röportaj / Konuşan Kafa · Tek kişi röportaj","Klinik / Estetik / Dental · Klinik sosyal medya içerikleri"],"top5Count":5},"gdx-cf-led-2020w-video-led-isik":{"family":"daylight_or_fixed_white","wattBand":"high","channelArchitecture":"BI_COLOR_CCT","nominalPowerW":120,"effectiveWhitePowerW":118,"effectiveCreativePowerW":26,"whiteRoleLabel":"Beyaz/CCT ana key ışık","creativeRoleLabel":"Beyaz destek ışığı; RGB/FX ana avantaj sınırlı","kelvinLabel":"5.600K","top5Purposes":["Klinik / Estetik / Dental · Cilt / yüz çekimi","Klinik / Estetik / Dental · Dental / ağız içi destek","Mobil / Dış Mekan · Mekan içi hızlı kurulum","Mobil / Dış Mekan · Taşınabilir ekip","Röportaj / Konuşan Kafa · Tek kişi röportaj"],"top5Count":5},"gdx-cf-led-1024w-60w-cri-95-bicolor-led-video-isigi-batarya-ve-sarj-cihazi-hediyeli":{"family":"bicolor","wattBand":"mid","channelArchitecture":"BI_COLOR_CCT","nominalPowerW":60,"effectiveWhitePowerW":59,"effectiveCreativePowerW":13,"whiteRoleLabel":"Yakın mesafe fill / destek ışığı","creativeRoleLabel":"Beyaz destek ışığı; RGB/FX ana avantaj sınırlı","kelvinLabel":"5.600K","top5Purposes":["Klinik / Estetik / Dental · Cilt / yüz çekimi","Klinik / Estetik / Dental · Dental / ağız içi destek","Mobil / Dış Mekan · Taşınabilir ekip","Mobil / Dış Mekan · Mekan içi hızlı kurulum","Mobil / Dış Mekan · Bataryalı çekim"],"top5Count":5},"gdx-p-750r-ii-rgbwy-canli-yayin-ve-podcast-video-isik-sistemi":{"family":"rgb","wattBand":"high","channelArchitecture":"RGBWY","nominalPowerW":150,"effectiveWhitePowerW":132,"effectiveCreativePowerW":150,"whiteRoleLabel":"Kontrollü beyaz key-fill + RGB destek","creativeRoleLabel":"RGB creative key + accent / atmosfer","kelvinLabel":"2.700K–6.500K","top5Purposes":["RGB / Kreatif Video · Arka plan renk efekti","RGB / Kreatif Video · Ürün arkasında renk ayrımı","RGB / Kreatif Video · Müzik / klip / kreatif sahne","Stüdyo / Profesyonel Çekim · Reklam / kampanya görseli","Stüdyo / Profesyonel Çekim · Model çekimi"],"top5Count":5},"gdx-cf-1000r-rgb-led-video-isigi":{"family":"rgb","wattBand":"high","channelArchitecture":"RGB_CCT","nominalPowerW":104,"effectiveWhitePowerW":94,"effectiveCreativePowerW":104,"whiteRoleLabel":"Kontrollü beyaz key-fill + RGB destek","creativeRoleLabel":"RGB creative key + accent / atmosfer","kelvinLabel":"2.700K–10.000K","top5Purposes":["RGB / Kreatif Video · Arka plan renk efekti","RGB / Kreatif Video · Ürün arkasında renk ayrımı","RGB / Kreatif Video · Müzik / klip / kreatif sahne","Mobil / Dış Mekan · Mekan içi hızlı kurulum","Mobil / Dış Mekan · Bataryalı çekim"],"top5Count":5},"gdx-cf-1500r-rgb-led-video-isigi":{"family":"rgb","wattBand":"high","channelArchitecture":"RGB_CCT","nominalPowerW":168,"effectiveWhitePowerW":151,"effectiveCreativePowerW":168,"whiteRoleLabel":"Kontrollü beyaz key-fill + RGB destek","creativeRoleLabel":"RGB creative key + accent / atmosfer","kelvinLabel":"2.700K–10.000K","top5Purposes":["RGB / Kreatif Video · Arka plan renk efekti","RGB / Kreatif Video · Ürün arkasında renk ayrımı","Mobil / Dış Mekan · Mekan içi hızlı kurulum","RGB / Kreatif Video · Müzik / klip / kreatif sahne","Mobil / Dış Mekan · Taşınabilir ekip"],"top5Count":5},"gdx-cf-led-600rgb-video-led-isik":{"family":"rgb","wattBand":"mid","channelArchitecture":"RGB_CCT","nominalPowerW":60,"effectiveWhitePowerW":54,"effectiveCreativePowerW":60,"whiteRoleLabel":"Yakın mesafe fill / destek ışığı","creativeRoleLabel":"RGB accent / fon / atmosfer ışığı","kelvinLabel":"3.200K–5.600K","top5Purposes":["RGB / Kreatif Video · Arka plan renk efekti","RGB / Kreatif Video · Ürün arkasında renk ayrımı","RGB / Kreatif Video · Müzik / klip / kreatif sahne","Mobil / Dış Mekan · Bataryalı çekim","Mobil / Dış Mekan · Taşınabilir ekip"],"top5Count":5}};
  const clean=v=>String(v??'').replace(/\s+/g,' ').trim();
  const q=(s,r=document)=>r.querySelector(s);
  const qa=(s,r=document)=>[...r.querySelectorAll(s)];
  const source=(()=>{try{return JSON.parse(q('#canfotoPdpRev85SourceContext')?.textContent||'{}')}catch(_){return {}}})();
  const handle=clean(source.handle)||(location.pathname.match(/^\/products\/([^/?#]+)/)||[])[1]||'';
  const RECENT_KEY='canfoto_recently_viewed_v1';
  let SOURCE_FACTS=null;

  function textNorm(v){return clean(v).replace(/\u00a0/g,' ')}

  function modelLabel(){
    const title=textNorm(source.title);
    const m=title.match(/\b(GDX|Godox)\s+([A-Z0-9-]+(?:\s+(?:II|III|IV|V|PRO))?)/i);
    return m?`${m[1]} ${m[2]}`:textNorm(source.vendor)||'Ürün';
  }

  /* Y-PDP-SOURCE-FACTS-R1: section-bounded, source-only read adapter.
     No product-type inference, no synthetic bundle contents, no DOM mutation. */
  function extractSourceFacts(){
    const raw=q('#urun-aciklamasi .pdp-source-description__body');
    const facts={rows:{},packageItems:[],note:'',signoff:'',bodyText:textNorm(raw?.textContent||''),diagnostic:{technicalRows:0,packageSource:'NONE'}};
    if(!raw) return facts;
    const root=raw.querySelector('#gdx-product-root')||raw;
    const heads=[...root.querySelectorAll('h2,h3,h4,h5')];
    const key=v=>textNorm(v).toLocaleLowerCase('tr-TR').replace(/[\s\u00a0]+/g,' ').replace(/[:：]$/,'').trim();
    const isTech=s=>/teknik (özellikler|parametreler)|teknik bilgiler/.test(key(s));
    const isPack=s=>/^(set ve kutu içeriği|standart paket kutu içeriği|paket içeriği|kutu içeriği|set içeriği|paketleme ve teslimat)$/.test(key(s));
    const isBoundary=s=>/^(öne çıkan özellikler|teknik özellikler|teknik parametreler|uyumlu markalar ve cihazlar|kullanım alanları|profesyonel kullanım senaryoları|paketleme ve teslimat|kutu içeriği|set ve kutu içeriği|opsiyonel|profesyonel not)/.test(key(s));
    const containerOf=h=>{
      const parent=h?.parentElement;
      if(!parent) return null;
      // Prefer a single semantic content block. Never climb to whole product root.
      if(parent.matches('.gdx-content-block,.gdx-table-container,.gdx-dark-specs'))return parent;
      const gp=parent.parentElement;
      if(gp&&gp!==root&&gp.matches('.gdx-content-block,.gdx-table-container,.gdx-dark-specs'))return gp;
      return parent;
    };
    const sectionNodes=h=>{
      const host=containerOf(h);if(!host)return [];
      // Heading can be a direct descendant of a dedicated semantic container.
      if(host!==h.parentElement&&host.querySelectorAll('h2,h3,h4,h5').length===1)return [host];
      if(host.matches('.gdx-content-block,.gdx-table-container,.gdx-dark-specs')&&host.querySelectorAll('h2,h3,h4,h5').length===1)return [host];
      const out=[];
      let node=h.nextElementSibling;
      while(node){
        if(node.matches('h2,h3,h4,h5')||node.querySelector('h2,h3,h4,h5'))break;
        out.push(node); node=node.nextElementSibling;
      }
      return out;
    };
    // Existing structured tables remain authoritative, even when unheaded.
    qa('table tr',root).forEach(tr=>{
      const cells=[...tr.querySelectorAll('th,td')].map(x=>textNorm(x.textContent));
      if(cells.length>=2&&cells[0]&&cells[cells.length-1])facts.rows[cells[0]]=cells[cells.length-1];
    });
    const addKV=li=>{
      const bold=li.querySelector(':scope > strong, :scope > b, strong:first-child, b:first-child');
      if(!bold)return;
      const label=textNorm(bold.textContent).replace(/[:：]$/,'').trim();
      const full=textNorm(li.textContent);
      const value=full.slice(textNorm(bold.textContent).length).replace(/^\s*[:：]\s*/,'').trim();
      if(label&&value&&!facts.rows[label])facts.rows[label]=value;
    };
    heads.filter(h=>isTech(h.textContent)).forEach(h=>sectionNodes(h).forEach(node=>{
      qa('li',node).forEach(addKV);
      if(node.matches('li'))addKV(node);
    }));
    const packageValues=[];
    const pushItem=s=>{const item=textNorm(s);if(item&&!packageValues.includes(item))packageValues.push(item)};
    heads.filter(h=>isPack(h.textContent)).forEach(h=>sectionNodes(h).forEach(node=>{
      const list=node.matches('li')?[node]:qa('li',node);
      list.forEach(li=>{
        const full=textNorm(li.textContent);
        const bold=li.querySelector('strong,b');
        const label=key(bold?.textContent||'');
        if(label==='kutu içeriği'){
          const remainder=full.slice(textNorm(bold.textContent).length).replace(/^\s*[:：]\s*/,'').trim();
          remainder.split(/[,;]+/).map(s=>s.trim()).filter(Boolean).forEach(pushItem);
        } else if(label==='satış birimi'||label==='paket boyutu'||label==='brüt ağırlık'||label.startsWith('opsiyonel')){
          // Logistics and optional sets are not included in the sold kit.
        } else if(!/^opsiyonel/i.test(full))pushItem(full);
      });
    }));
    facts.packageItems=packageValues;
    facts.diagnostic={technicalRows:Object.keys(facts.rows).length,packageSource:packageValues.length?'HEADING_BOUNDED':'NONE',packageCount:packageValues.length};
    const noteP=[...root.querySelectorAll('p')].find(x=>/Profesyonel\s*Not/i.test(textNorm(x.textContent)));
    if(noteP)facts.note=textNorm(noteP.textContent);
    const foot=root.querySelector('footer');if(foot)facts.signoff=textNorm(foot.textContent);
    return facts;
  }

  const CF_DESC_OWNER_VERSION='CANFOTO-INTERIM-PDP-C2-R5-UNIFIED-DESKTOP-MEDIA-GALLERY';
  let CF_DESC_STATE={
    version:CF_DESC_OWNER_VERSION,
    status:'IDLE',
    textParity:false,
    sourceTextLength:0,
    renderedTextLength:0,
    unsafeNodesRemoved:0,
    inlineStylesRemoved:0,
    legacyClassesRemoved:0,
    legacyIdsRemoved:0,
    presentationAttrsRemoved:0,
    mediaBefore:0,
    mediaAfter:0,
    tablesBefore:0,
    tablesAfter:0,
    linksBefore:0,
    linksAfter:0,
    compactMediaCandidates:0,
    compactMediaExpandable:0,
    compactMediaDesktopOnly:true,
    mode:'SOURCE_FALLBACK'
  };

  function cfDescMeaningfulText(root){
    const clone=root?.cloneNode?.(true);
    if(!clone) return '';
    qa('script,style,noscript,template,form,input,button,select,textarea,meta,link,object,embed',clone).forEach(x=>x.remove());
    return textNorm(clone.textContent||'');
  }

  function cfDescCount(root,selector){
    return root?qa(selector,root).length:0;
  }

  function cfDescUnsafeUrl(value){
    return /^\s*(?:javascript|vbscript):/i.test(String(value||''));
  }

  function cfDescSanitize(root,stats){
    const DROP='script,style,noscript,template,form,input,button,select,textarea,meta,link,object,embed';
    const doomed=qa(DROP,root);
    stats.unsafeNodesRemoved+=doomed.length;
    doomed.forEach(x=>x.remove());

    const all=[root,...qa('*',root)];
    all.forEach(el=>{
      if(!(el instanceof Element)) return;

      /* Preserve common lazy-media sources before legacy data-* attributes are removed. */
      if(/^(IMG|IFRAME|VIDEO|SOURCE)$/i.test(el.tagName)){
        if(!el.getAttribute('src')&&el.getAttribute('data-src')) el.setAttribute('src',el.getAttribute('data-src'));
        if(!el.getAttribute('srcset')&&el.getAttribute('data-srcset')) el.setAttribute('srcset',el.getAttribute('data-srcset'));
      }

      [...el.attributes].forEach(attr=>{
        const name=attr.name.toLowerCase();

        if(name==='style'){
          stats.inlineStylesRemoved++;
          el.removeAttribute(attr.name);
          return;
        }
        if(name==='class'){
          stats.legacyClassesRemoved++;
          el.removeAttribute(attr.name);
          return;
        }
        if(name==='id'){
          stats.legacyIdsRemoved++;
          el.removeAttribute(attr.name);
          return;
        }
        if(/^on/i.test(name)||/^data-/i.test(name)){
          stats.presentationAttrsRemoved++;
          el.removeAttribute(attr.name);
          return;
        }
        if(['width','height'].includes(name)){
          const keepIntrinsicDimension=/^(IMG|VIDEO)$/i.test(el.tagName) && /^\d+$/.test(clean(attr.value));
          if(keepIntrinsicDimension) return;
          stats.presentationAttrsRemoved++;
          el.removeAttribute(attr.name);
          return;
        }
        if(['align','bgcolor','color','face','size','border','cellpadding','cellspacing'].includes(name)){
          stats.presentationAttrsRemoved++;
          el.removeAttribute(attr.name);
          return;
        }
        if((name==='href'||name==='src'||name==='xlink:href')&&cfDescUnsafeUrl(attr.value)){
          stats.presentationAttrsRemoved++;
          el.removeAttribute(attr.name);
        }
      });

      if(el.tagName==='IMG'){
        el.loading='lazy';
        el.decoding='async';
        /* Preserve authored alt text. Missing alt stays empty instead of
           receiving repetitive generic keyword-like copy. */
        if(!el.hasAttribute('alt')) el.setAttribute('alt','');
      }
      if(el.tagName==='IFRAME'){
        el.loading='lazy';
        if(!el.title) el.title='Ürün açıklaması videosu';
      }
      if(el.tagName==='A'){
        const target=clean(el.getAttribute('target'));
        if(target==='_blank') el.setAttribute('rel','noopener noreferrer');
      }
    });
  }


  function cfDescReplaceTag(el,tagName,className=''){
    const next=document.createElement(tagName);
    [...el.attributes].forEach(attr=>next.setAttribute(attr.name,attr.value));
    if(className) next.classList.add(className);
    while(el.firstChild) next.appendChild(el.firstChild);
    el.replaceWith(next);
    return next;
  }

  function cfDescNormalizeHeadings(root){
    const titleKey=textNorm(source.title).toLocaleLowerCase('tr-TR');

    /* Shopify product.title owns the PDP H1. */
    qa('h1,h2',root).forEach(el=>{
      const key=textNorm(el.textContent).toLocaleLowerCase('tr-TR');
      if(key && titleKey && key===titleKey){
        cfDescReplaceTag(el,'p','cf-desc-product-title');
      }else{
        cfDescReplaceTag(el,'h3');
      }
    });
  }

  function cfDescDirectChildren(el,selector){
    try{return [...el.children].filter(x=>x.matches(selector));}
    catch(_){return [];}
  }

  function cfDescHasDirectHeading(el){
    return cfDescDirectChildren(el,'h1,h2,h3,h4,h5,h6').length>0;
  }

  function cfDescHasDirectBody(el){
    return cfDescDirectChildren(el,'p,ul,ol,blockquote,dl').length>0;
  }


  function cfDescLogicalCellCount(row){
    return [...row.cells].reduce((sum,cell)=>sum+Math.max(1,Number(cell.colSpan)||1),0);
  }

  function cfDescHeaderLabels(table){
    const first=[...table.rows].find(row=>row.cells.length>0);
    if(!first) return [];
    return [...first.cells].map(cell=>textNorm(cell.textContent).toLocaleLowerCase('tr-TR'));
  }

  function cfDescNormalizeTables(root){
    qa('table',root).forEach(table=>{
      const rows=[...table.rows];
      const maxCols=Math.max(1,...rows.map(cfDescLogicalCellCount));

      table.classList.add('cf-desc-table');
      table.dataset.cfTableCols=String(maxCols);
      table.classList.add(`cf-desc-table--cols-${Math.min(maxCols,8)}`);
      table.classList.toggle('cf-desc-table--key-value',maxCols===2);
      table.classList.toggle('cf-desc-table--matrix',maxCols>=3);

      const labels=cfDescHeaderLabels(table);
      const firstLabel=labels[0]||'';
      const hasIndexHeader=/^(?:no|no\.|#|sıra|sira|numara)$/i.test(firstLabel);
      if(hasIndexHeader) table.classList.add('cf-desc-table--indexed');

      rows.forEach((row,rowIndex)=>{
        row.dataset.cfTableRow=String(rowIndex);
        let logicalIndex=0;
        [...row.cells].forEach(cell=>{
          const span=Math.max(1,Number(cell.colSpan)||1);
          cell.dataset.cfCol=String(logicalIndex+1);
          cell.dataset.cfColSpan=String(span);

          if(hasIndexHeader && logicalIndex===0){
            cell.classList.add('cf-desc-col-index');
          }

          const headerLabel=labels[logicalIndex]||'';
          if(/(?:kelvin|cct|renk\s*sıcaklığı|renk\s*sicakligi)/i.test(headerLabel)){
            cell.classList.add('cf-desc-col-nowrap','cf-desc-col-measure');
          }else if(/(?:watt|volt|lümen|lumen|lux|cri|tlci|kg|cm|mm|mah)/i.test(headerLabel)){
            cell.classList.add('cf-desc-col-measure');
          }

          logicalIndex+=span;
        });
      });

      const firstRow=rows[0]||null;
      const hasHeaderCells=!!firstRow&&[...firstRow.cells].some(cell=>cell.tagName==='TH');
      table.classList.toggle('cf-desc-table--has-head',hasHeaderCells);

      /* Never reorder, transpose or rewrite source table cells. */
    });
  }

  function cfDescWrapTables(root){
    qa('table',root).forEach(table=>{
      if(table.parentElement?.classList.contains('cf-desc-table-scroll')) return;
      const wrap=document.createElement('div');
      wrap.className='cf-desc-table-scroll';
      table.before(wrap);
      wrap.appendChild(table);
    });
  }

  function cfDescMarkTechnical(root){
    qa('table',root).forEach(table=>{
      let n=table.parentElement;
      let owner=null;
      while(n&&n!==root){
        if(/^(SECTION|ARTICLE|DIV)$/i.test(n.tagName)&&cfDescHasDirectHeading(n)){owner=n;break;}
        n=n.parentElement;
      }
      if(!owner) owner=table.closest('section,article,div')||table.parentElement;
      if(owner&&owner!==root) owner.classList.add('cf-desc-tech');
    });
  }

  /* Q PDP PILOT V1: Preserve raw list text and DOM nodes. Label/value pairs
     under explicit technical heading receive a table-like CSS layout.
     No new <table> or cells: exact text/table/media/link parity stays intact. */
  function cfDescMarkTechnicalLists(root){
    qa('h2,h3,h4,h5,h6',root).forEach(heading=>{
      const title=textNorm(heading.textContent).toLocaleLowerCase('tr-TR');
      if(!/(teknik\s+(?:özellikler|parametreler)|teknik\s+bilgiler|technical\s+specifications)/i.test(title)) return;
      let list=heading.nextElementSibling;
      while(list&&/^(P|DIV)$/i.test(list.tagName)&&!list.querySelector('li')&&!textNorm(list.textContent)) list=list.nextElementSibling;
      if(!list||!/^(UL|OL)$/i.test(list.tagName)) return;
      const items=[...list.children].filter(x=>x.tagName==='LI');
      if(items.length<3||items.some(li=>!li.querySelector('strong,b')||!textNorm(li.textContent).includes(':'))) return;
      list.classList.add('cf-desc-spec-kv-list');
      list.dataset.cfSemanticPilot='TECHNICAL_LABEL_VALUE_V1';
      items.forEach(li=>li.classList.add('cf-desc-spec-kv-row'));
    });
  }

  function cfDescMarkGrids(root){
    qa('div,section,article',root).forEach(parent=>{
      if(parent.classList.contains('cf-desc-tech')) return;
      const children=[...parent.children].filter(x=>/^(DIV|SECTION|ARTICLE)$/i.test(x.tagName));
      if(children.length<2||children.length>6) return;
      const cardLike=children.every(child=>
        cfDescHasDirectHeading(child)&&
        (cfDescHasDirectBody(child)||child.querySelector('img,picture,video,iframe'))
      );
      if(!cardLike) return;
      parent.classList.add('cf-desc-grid');
      children.forEach(child=>child.classList.add('cf-desc-card'));
    });
  }

  function cfDescMarkNotes(root){
    const noteRe=/^(?:profesyonel\s*not|önemli\s*not|not|uyarı|dikkat|ipucu|professional\s*note|note)\s*:/i;
    qa('p,div,section,article',root).forEach(el=>{
      const text=textNorm(el.textContent);
      if(!text||text.length>1400||!noteRe.test(text)) return;
      let owner=el;
      if(el.tagName==='P'&&el.parentElement&&el.parentElement!==root&&el.parentElement.children.length<=2){
        owner=el.parentElement;
      }
      owner.classList.add('cf-desc-note');
    });
  }

  function cfDescMarkCallouts(root){
    qa('div,section,article',root).forEach(el=>{
      if(el.classList.contains('cf-desc-grid')||
         el.classList.contains('cf-desc-card')||
         el.classList.contains('cf-desc-tech')||
         el.classList.contains('cf-desc-note')||
         el.closest('header,footer')) return;
      if(cfDescHasDirectHeading(el)&&cfDescHasDirectBody(el)){
        el.classList.add('cf-desc-callout');
      }
    });
  }

  function cfDescMarkMedia(root){
    qa('img,picture,video,iframe',root).forEach(media=>{
      const parent=media.parentElement;
      if(parent&&parent!==root&&!parent.classList.contains('cf-desc-table-scroll')){
        parent.classList.add('cf-desc-media');
      }
    });
  }



  const CF_DESC_MEDIA_ORIGINS=new Map();
  let CF_DESC_MEDIA_GALLERY=null;
  let CF_DESC_MEDIA_MQ_BOUND=false;
  let CF_DESC_MEDIA_STATE={descriptionImageCount:0,galleryItemCount:0,galleryActive:false,desktopOnly:true};

  function cfDescImageUnits(root){
    const out=[],seen=new Set();
    qa('picture,img',root).forEach(node=>{
      if(node.tagName==='IMG'&&node.closest('picture')) return;
      let unit=node;
      const anchor=node.closest('a');
      if(anchor&&root.contains(anchor)&&textNorm(anchor.textContent)===''&&qa('img,picture',anchor).length===1) unit=anchor;
      if(!seen.has(unit)){seen.add(unit);out.push(unit);}
    });
    return out;
  }

  function cfDescSetExpanded(item,expanded){
    item.classList.toggle('is-expanded',!!expanded);
    item.dataset.cfDescExpanded=expanded?'true':'false';
    item.setAttribute('aria-expanded',expanded?'true':'false');
    item.setAttribute('aria-label',expanded?'Görseli küçült':'Görseli büyüt');
  }

  function cfDescRestoreGallery(root){
    [...CF_DESC_MEDIA_ORIGINS.entries()].forEach(([unit,origin])=>{
      if(origin?.parentNode){
        origin.parentNode.insertBefore(unit,origin.nextSibling);
        origin.remove();
      }
    });
    CF_DESC_MEDIA_ORIGINS.clear();
    CF_DESC_MEDIA_GALLERY?.remove();
    CF_DESC_MEDIA_GALLERY=null;
    CF_DESC_MEDIA_STATE.galleryActive=false;
    CF_DESC_MEDIA_STATE.galleryItemCount=0;
  }

  function cfDescBuildGallery(root){
    if(CF_DESC_MEDIA_GALLERY?.isConnected){
      CF_DESC_MEDIA_STATE.galleryActive=true;
      CF_DESC_MEDIA_STATE.galleryItemCount=CF_DESC_MEDIA_GALLERY.querySelectorAll('.cf-desc-media-gallery-item').length;
      return;
    }

    const units=cfDescImageUnits(root);
    CF_DESC_MEDIA_STATE.descriptionImageCount=qa('img',root).length;
    if(!units.length) return;

    const gallery=document.createElement('div');
    gallery.className='cf-desc-media-gallery';
    gallery.dataset.cfDescMediaGallery='desktop';
    gallery.setAttribute('aria-label','Ürün açıklaması görselleri');

    let insertion=units[0];
    while(insertion.parentElement&&insertion.parentElement!==root) insertion=insertion.parentElement;
    root.insertBefore(gallery,insertion);

    units.forEach((unit,index)=>{
      const origin=document.createComment(`cf-desc-media-origin-${index+1}`);
      unit.parentNode.insertBefore(origin,unit);
      CF_DESC_MEDIA_ORIGINS.set(unit,origin);

      const item=document.createElement('div');
      item.className='cf-desc-media-gallery-item';
      item.dataset.cfDescMediaIndex=String(index+1);
      item.setAttribute('role','button');
      item.setAttribute('tabindex','0');
      cfDescSetExpanded(item,false);

      unit.classList.add('cf-desc-media-gallery-unit');
      item.appendChild(unit);
      gallery.appendChild(item);

      const toggle=e=>{
        if(window.matchMedia('(max-width: 900px)').matches) return;
        e.preventDefault();
        e.stopPropagation();
        const next=item.dataset.cfDescExpanded!=='true';
        if(next){
          qa('.cf-desc-media-gallery-item.is-expanded',gallery).forEach(other=>{
            if(other!==item) cfDescSetExpanded(other,false);
          });
        }
        cfDescSetExpanded(item,next);
      };
      item.addEventListener('click',toggle);
      item.addEventListener('keydown',e=>{
        if(e.key==='Enter'||e.key===' ') toggle(e);
      });
    });

    CF_DESC_MEDIA_GALLERY=gallery;
    CF_DESC_MEDIA_STATE.galleryActive=true;
    CF_DESC_MEDIA_STATE.galleryItemCount=gallery.querySelectorAll('.cf-desc-media-gallery-item').length;
  }

  function cfDescSyncGallery(root){
    const desktop=!window.matchMedia('(max-width: 900px)').matches;
    if(desktop) cfDescBuildGallery(root);
    else cfDescRestoreGallery(root);

    CF_DESC_MEDIA_STATE.descriptionImageCount=qa('img',root).length;

    if(!CF_DESC_MEDIA_MQ_BOUND){
      const mq=window.matchMedia('(max-width: 900px)');
      const onChange=()=>{
        const current=q('#urun-aciklamasi .cf-owned-description');
        if(current) cfDescSyncGallery(current);
      };
      if(mq.addEventListener) mq.addEventListener('change',onChange);
      else mq.addListener(onChange);
      CF_DESC_MEDIA_MQ_BOUND=true;
    }
  }

  function cfDescMarkChrome(root){
    qa('header',root).forEach(x=>x.classList.add('cf-desc-header'));
    qa('footer',root).forEach(x=>x.classList.add('cf-desc-footer'));

    qa('.cf-desc-header',root).forEach(header=>{
      [...header.children].forEach(child=>{
        if(/^(DIV|SPAN|P)$/i.test(child.tagName) &&
           !child.querySelector('h1,h2,h3,h4,h5,h6,p,ul,ol,table,img,picture,video,iframe') &&
           textNorm(child.textContent).length>0 &&
           textNorm(child.textContent).length<=90){
          child.classList.add('cf-desc-kicker');
        }
      });
    });
  }

  function cfDescAnnotate(root){
    cfDescMarkChrome(root);
    cfDescNormalizeTables(root);
    cfDescWrapTables(root);
    cfDescMarkTechnical(root);
    cfDescMarkTechnicalLists(root);
    cfDescMarkGrids(root);
    cfDescMarkNotes(root);
    cfDescMarkCallouts(root);
    cfDescMarkMedia(root);
    cfDescSyncGallery(root);

    qa('details',root).forEach(x=>x.classList.add('cf-desc-details'));
    qa('blockquote',root).forEach(x=>x.classList.add('cf-desc-quote'));
    qa('pre',root).forEach(x=>x.classList.add('cf-desc-code'));
  }

  function cfDescSourceFrame(clone){
    const hasTopText=[...clone.childNodes].some(n=>n.nodeType===Node.TEXT_NODE&&textNorm(n.nodeValue));
    if(!hasTopText&&clone.children.length===1){
      const only=clone.firstElementChild;
      if(only&&/^(DIV|SECTION|ARTICLE|MAIN)$/i.test(only.tagName)) return only;
    }
    return clone;
  }

  function cfDescSetApi(){
    window.CANFOTO_PDP_DESCRIPTION_RENDERER=Object.freeze({
      version:CF_DESC_OWNER_VERSION,
      getState:()=>JSON.parse(JSON.stringify(CF_DESC_STATE))
    });
  }

  function rebuildSourceDescription(){
    const section=q('#urun-aciklamasi.pdp-source-description.cf39-source-truth');
    const raw=q('.pdp-source-description__body',section);
    if(!section||!raw) return false;
    if(raw.dataset.cfDescriptionOwner===CF_DESC_OWNER_VERSION){
      cfDescSetApi();
      return false;
    }

    SOURCE_FACTS=extractSourceFacts();

    const sourceText=cfDescMeaningfulText(raw);
    const sourceMedia=cfDescCount(raw,'img,video,iframe');
    const sourceTables=cfDescCount(raw,'table');
    const sourceTableRows=cfDescCount(raw,'table tr');
    const sourceTableCells=cfDescCount(raw,'table th,table td');
    const sourceLinks=cfDescCount(raw,'a[href]');

    const clone=raw.cloneNode(true);
    const stats={
      unsafeNodesRemoved:0,
      inlineStylesRemoved:0,
      legacyClassesRemoved:0,
      legacyIdsRemoved:0,
      presentationAttrsRemoved:0
    };

    try{
      cfDescSanitize(clone,stats);
      cfDescNormalizeHeadings(clone);

      const owned=document.createElement('div');
      owned.className='cf-owned-description';
      owned.dataset.cfDescriptionOwner=CF_DESC_OWNER_VERSION;
      owned.setAttribute('role','document');

      const frame=cfDescSourceFrame(clone);
      const nodes=[...frame.childNodes];
      nodes.forEach(node=>owned.appendChild(node));

      cfDescAnnotate(owned);

      const renderedText=textNorm(owned.textContent||'');
      const renderedMedia=cfDescCount(owned,'img,video,iframe');
      const renderedTables=cfDescCount(owned,'table');
      const renderedTableRows=cfDescCount(owned,'table tr');
      const renderedTableCells=cfDescCount(owned,'table th,table td');
      const renderedLinks=cfDescCount(owned,'a[href]');

      const textParity=renderedText===sourceText;
      const mediaParity=renderedMedia===sourceMedia;
      const tableParity=renderedTables===sourceTables;
      const tableRowParity=renderedTableRows===sourceTableRows;
      const tableCellParity=renderedTableCells===sourceTableCells;
      const linkParity=renderedLinks===sourceLinks;

      if(!textParity||!mediaParity||!tableParity||!tableRowParity||!tableCellParity||!linkParity){
        CF_DESC_STATE={
          version:CF_DESC_OWNER_VERSION,
          status:'FAIL_CLOSED_PARITY',
          textParity,
          sourceTextLength:sourceText.length,
          renderedTextLength:renderedText.length,
          ...stats,
          mediaBefore:sourceMedia,mediaAfter:renderedMedia,
          tablesBefore:sourceTables,tablesAfter:renderedTables,
          tableRowsBefore:sourceTableRows,tableRowsAfter:renderedTableRows,
          tableCellsBefore:sourceTableCells,tableCellsAfter:renderedTableCells,
          linksBefore:sourceLinks,linksAfter:renderedLinks,
          mode:'SOURCE_FALLBACK'
        };
        raw.dataset.cfDescriptionStatus='FAIL_CLOSED_PARITY';
        cfDescSetApi();
        return false;
      }

      raw.replaceChildren(owned);
      raw.dataset.cf85StructuredSource='1';
      raw.dataset.cfDescriptionOwner=CF_DESC_OWNER_VERSION;
      raw.dataset.cfDescriptionMode='CANFOTO_OWNED_COMPACT';
      raw.dataset.cfDescriptionStatus='READY';
      section.dataset.cf39MediaSource='shopify-product-body-html-normalized';
      section.dataset.cfDescriptionOwner=CF_DESC_OWNER_VERSION;

      const label=q('.pdp-source-description__head .shop-label',section);
      if(label) label.textContent='ÜRÜN DETAYLARI';
      const head=q('.pdp-source-description__head h2',section);
      if(head) head.textContent='Ürün açıklaması ve teknik özellikler';

      CF_DESC_STATE={
        version:CF_DESC_OWNER_VERSION,
        status:'READY',
        textParity:true,
        sourceTextLength:sourceText.length,
        renderedTextLength:renderedText.length,
        ...stats,
        mediaBefore:sourceMedia,mediaAfter:renderedMedia,
        tablesBefore:sourceTables,tablesAfter:renderedTables,
        tableRowsBefore:sourceTableRows,tableRowsAfter:renderedTableRows,
        tableCellsBefore:sourceTableCells,tableCellsAfter:renderedTableCells,
        linksBefore:sourceLinks,linksAfter:renderedLinks,
        ...CF_DESC_MEDIA_STATE,
        mode:'CANFOTO_OWNED_COMPACT'
      };
      cfDescSetApi();
      return true;
    }catch(error){
      CF_DESC_STATE={
        version:CF_DESC_OWNER_VERSION,
        status:'FAIL_CLOSED_EXCEPTION',
        textParity:false,
        sourceTextLength:sourceText.length,
        renderedTextLength:0,
        ...stats,
        mediaBefore:sourceMedia,mediaAfter:sourceMedia,
        tablesBefore:sourceTables,tablesAfter:sourceTables,
        tableRowsBefore:sourceTableRows,tableRowsAfter:sourceTableRows,
        tableCellsBefore:sourceTableCells,tableCellsAfter:sourceTableCells,
        linksBefore:sourceLinks,linksAfter:sourceLinks,
        mode:'SOURCE_FALLBACK',
        error:String(error?.message||error||'UNKNOWN')
      };
      raw.dataset.cfDescriptionStatus='FAIL_CLOSED_EXCEPTION';
      cfDescSetApi();
      return false;
    }
  }

  function factBy(){
    if(!SOURCE_FACTS) SOURCE_FACTS=extractSourceFacts();
    const rows=SOURCE_FACTS?.rows||{};
    const keys=[...arguments];
    for(const wanted of keys){
      const hit=Object.entries(rows).find(([k])=>textNorm(k).toLocaleLowerCase('tr-TR').includes(textNorm(wanted).toLocaleLowerCase('tr-TR')));
      if(hit && hit[1]) return hit[1];
    }
    return '';
  }

  function currentProductRecord(){
    const imgs=qa('.pdp-gallery img').map(img=>img.currentSrc||img.src).filter(Boolean);
    const unique=[...new Set(imgs)];
    const price=Number(source.variant?.priceMinor||0)/100;
    const compare=Number(source.variant?.compareAtPriceMinor||0)/100;
    return {
      handle,
      title:textNorm(source.title),
      vendor:textNorm(source.vendor),
      price:isFinite(price)?price:0,
      compare:isFinite(compare)&&compare>price?compare:0,
      image:unique[0]||'',
      images:unique.slice(0,12),
      url:location.pathname,
      variantId:String(source.variant?.id||''),
      available:source.variant?.available!==false
    };
  }

  function recentGet(){
    try{return JSON.parse(localStorage.getItem(RECENT_KEY)||'[]')}catch(_){return []}
  }
  function recentSet(list){
    try{localStorage.setItem(RECENT_KEY,JSON.stringify((list||[]).slice(0,12)))}catch(_){}
  }
  function recentRecord(p){
    if(!p?.handle) return;
    const list=recentGet().filter(x=>x&&x.handle!==p.handle);
    list.unshift(p); recentSet(list);
  }
  function moneyTl(v){
    const n=Number(v);
    if(!isFinite(n)||!n) return '';
    return Math.round(n).toLocaleString('tr-TR')+' TL';
  }
  function esc(v){
    return String(v||'').replace(/[&<>"']/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch]));
  }
  /* R14C — R14B PDP-only card renderer retired.
     HOME + COLLECTION + PDP product-card presentation is now owned only by
     canfoto-unified-product-card.js. The stubs preserve the existing boot
     contract without a second competing presentation owner. */
  function renderRecent(){ return true; }
  function cfR14bEnhanceRelated(){ return true; }

  function syncExperience(){
    const theme=clean(document.documentElement.dataset.cfTheme||'cf-editorial');
    const exp=theme.replace(/^cf-/,'')||'editorial';
    document.body.dataset.cf45Experience=exp;
    document.body.dataset.cf64SupportRhythm='true';
    document.body.dataset.canfotoPdpV18='true';
    document.body.dataset.canfotoPdpV27='true';
  }
  syncExperience();
  new MutationObserver(syncExperience).observe(document.documentElement,{attributes:true,attributeFilter:['data-cf-theme']});

  function fmt(v,suffix=''){
    if(v===null||v===undefined||v==='') return '';
    return `${v}${suffix}`;
  }

  function cobTruth(){
    const m=source.metafields||{};
    const cct=(m.cob_cct_min_k&&m.cob_cct_max_k)?`${m.cob_cct_min_k}K–${m.cob_cct_max_k}K`:'';
    const controls=[m.cob_dmx?'DMX512':'',m.cob_bluetooth?'Bluetooth':''].filter(Boolean).join(' · ');
    return {
      family:clean(m.cob_color_family)||clean(source.productType),
      power:(m.cob_watt?fmt(m.cob_watt,'W'):'')||factBy('Güç Çıkışı','Güç'),
      kelvin:cct||factBy('Renk Sıcaklığı','Kelvin'),
      cri:(m.cob_cri?`CRI ${m.cob_cri}`:'')||factBy('Renk Doğruluğu','CRI'),
      control:controls||factBy('Bağlantı Tipi','Montaj'),
      controlLabel:controls?'Kontrol':(factBy('Bağlantı Tipi','Montaj')?'Montaj':'Kontrol'),
      warranty:factBy('Garanti Süresi','Garanti'),
      role:'',
      creative:'',
      top5Purposes:[]
    };
  }

  function standardTruth(){
    return {
      family:clean(source.productType)||clean(source.collectionTitle)||'Ürün',
      power:factBy('Çıkış Gücü','Maksimum Güç','Güç'),
      kelvin:factBy('Renk Sıcaklığı','Kelvin'),
      cri:factBy('Renksel Geriverim İndeksi','Renk Doğruluğu','CRI','TLCI'),
      control:factBy('Kontrol Mekanizması','Kontrol Modu','Bağlantı Tipi'),
      controlLabel:'Kontrol / Montaj',
      role:'',
      creative:'',
      top5Purposes:[]
    };
  }

  function channelLabel(v){
    const key=clean(v).toUpperCase().replace(/[\s-]+/g,'_');
    const map={
      BI_COLOR_CCT:'Bi-Color CCT',
      BICOLOR_CCT:'Bi-Color CCT',
      RGB:'RGB',
      RGB_CCT:'RGB + CCT',
      RGBW:'RGBW',
      RGBWW:'RGBWW',
      RGBWY:'RGBWY',
      DAYLIGHT:'Sabit Günışığı',
      FIXED_WHITE:'Sabit Beyaz'
    };
    return map[key]||clean(v).replace(/_/g,' ');
  }

  function panelTruth(p){
    /* C1S/P47 read-only evidence may describe family, power, Kelvin and role.
       It must NOT be reinterpreted as an optical measurement:
       - channelArchitecture is NOT CRI/Ra/TLCI,
       - whiteRoleLabel/creativeRoleLabel is NOT a control protocol.
       CRI/control/mount come only from actual Shopify Body HTML source facts. */
    const actualCri=factBy('Renk Doğruluğu','CRI','TLCI');
    const actualControl=factBy('Kontrol Yöntemi','Kontrol','DMX','Bluetooth','Kablosuz');
    const actualMount=factBy('Bağlantı Tipi','Montaj','Mount');
    const channel=channelLabel(p.channelArchitecture);
    let fifthValue='', fifthLabel='Kontrol';
    if(actualControl){ fifthValue=actualControl; fifthLabel='Kontrol'; }
    else if(actualMount){ fifthValue=actualMount; fifthLabel='Montaj'; }
    else if(channel){ fifthValue=channel; fifthLabel='Kanal / Renk Modu'; }

    return {
      family:p.family==='rgb'?'RGB Panel LED':(p.family==='bicolor'?'Bi-Color Panel LED':clean(source.productType)),
      power:p.nominalPowerW?`${p.nominalPowerW}W`:'',
      kelvin:clean(p.kelvinLabel)||factBy('Renk Sıcaklığı','Kelvin','CCT'),
      cri:actualCri,
      control:fifthValue,
      controlLabel:fifthLabel,
      channel,
      role:clean(p.whiteRoleLabel),
      creative:clean(p.creativeRoleLabel),
      top5Purposes:Array.isArray(p.top5Purposes)?p.top5Purposes:[],
      semanticSource:'C1S_PANEL_READONLY_PLUS_SHOPIFY_BODY_FACTS',
      channelArchitectureAsCri:false,
      roleAsControl:false
    };
  }

  function productTruth(){
    const p=PANEL[handle];
    if(p) return panelTruth(p);
    const cob=cobTruth();
    if(cob.power||cob.kelvin||cob.cri||cob.family) return {...cob,semanticSource:'COB_METAFIELDS_PLUS_SHOPIFY_BODY_FACTS'};
    return {...standardTruth(),semanticSource:'SHOPIFY_PRODUCT_SOURCE'};
  }

  /* ========================================================
     E1-F10 R13 · PDP NORA USE-CONTEXT EXPANSION — READ ONLY
     Source-backed static projection. No live motor/scoring on PDP load.
     ======================================================== */
  const R13_DATA=Object.freeze({"version":"CANFOTO-E1-F10-R13-PDP-NORA-USE-CONTEXT-PROJECTION-R1","source":{"cobSnapshotVersion":"CANFOTO-E1-F07B-C1S-A-COB-STATIC-TOP5-FREEZE-R2","cobSnapshotSha256":"b478f017bc3e13c1a9f6efbccbe67ac3ddade06f3bb2586876fdc3accab9615a","panelSnapshotVersion":"CANFOTO-E1-F07B-C1S-B-PANEL-STATIC-TOP5-FREEZE-R4","panelSnapshotSha256":"b8c03784cafd5d2e14c9206498008ecd6b5604b738d87c2f36e0cc3b8ab57b1a","cobPurposeCatalogVersion":"COB-V5-FAZ09.3-PURPOSE-CAPABILITY-RELEVANCE-MATRIX-V1","panelSelectionCatalogVersion":"PANEL-V4-U7E1-CANONICAL-PROFILES + R27_SELECTION_IDENTITY_BRIDGE"},"cobCatalog":[{"key":"youtube_reels_single_person","label":"YouTube / Reels / Tek Kişi Video","group":"İçerik Üretimi / Masa Başı"},{"key":"podcast_audio_sensitive","label":"Podcast / Ses Hassas Kayıt","group":"İçerik Üretimi / Masa Başı"},{"key":"webinar_online_course","label":"Webinar / Online Ders / Eğitim","group":"İçerik Üretimi / Masa Başı"},{"key":"room_natural_background","label":"Oda / Doğal Fon Atmosferi","group":"İçerik Üretimi / Masa Başı"},{"key":"single_person_interview","label":"Tek Kişi Röportaj","group":"Röportaj / Kurumsal"},{"key":"corporate_talking_head","label":"Kurumsal Konuşma / Talking Head","group":"Röportaj / Kurumsal"},{"key":"two_person_interview_key_start","label":"İki Kişi Röportaj İçin Ana Işık Başlangıcı","group":"Röportaj / Kurumsal"},{"key":"tabletop_small_product","label":"Küçük Ürün / Tabletop","group":"Ürün / E-Ticaret"},{"key":"catalog_white_background_key","label":"Beyaz Fon Katalog İçin Ürün Ana Işığı","group":"Ürün / E-Ticaret"},{"key":"product_video_reels","label":"Ürün Videosu / Reels","group":"Ürün / E-Ticaret"},{"key":"reflective_jewelry_glossy","label":"Parlak / Yansıtıcı Ürün ve Takı","group":"Ürün / E-Ticaret"},{"key":"food_culinary","label":"Gıda / Yemek / Masaüstü Sunum","group":"Ürün / E-Ticaret"},{"key":"cosmetics_packaging_color","label":"Kozmetik / Ambalaj Renk Doğruluğu","group":"Ürün / E-Ticaret"},{"key":"portrait_headshot","label":"Tek Kişi Portre / Headshot","group":"Portre / Model / Beauty"},{"key":"fashion_model_key","label":"Moda / Model Çekimi İçin Ana Işık","group":"Portre / Model / Beauty"},{"key":"makeup_beauty","label":"Makyaj / Beauty Yüz Işığı","group":"Portre / Model / Beauty"},{"key":"hair_salon_content","label":"Saç / Kuaför / Salon İçeriği","group":"Portre / Model / Beauty"},{"key":"baby_family_soft_key","label":"Bebek / Aile İçin Yumuşak Ana Işık","group":"Portre / Model / Beauty"},{"key":"dental_closeup_documentation","label":"Dental Yakın Plan Foto / Video Dokümantasyonu","group":"Klinik / Dental Dokümantasyon"},{"key":"clinical_aesthetic_before_after","label":"Klinik / Estetik Öncesi–Sonrası Kayıt","group":"Klinik / Dental Dokümantasyon"},{"key":"procedure_technical_closeup","label":"Teknik Yakın Plan / Prosedür Videosu","group":"Klinik / Dental Dokümantasyon"},{"key":"live_sales_face_product","label":"Canlı Satışta Yüz + Ürün Ana Işığı","group":"Canlı Satış / Showroom"},{"key":"showroom_demo","label":"Showroom / Demo / Ürün Anlatımı","group":"Canlı Satış / Showroom"},{"key":"brand_color_live_background","label":"Marka Rengi Fonlu Canlı Yayın","group":"Canlı Satış / Showroom"},{"key":"field_interview","label":"Saha Röportajı","group":"Mobil / Dış Çekim"},{"key":"travel_vlog_creator","label":"Seyahat / VLOG / Creator","group":"Mobil / Dış Çekim"},{"key":"location_portrait_video","label":"Lokasyon Portre / Video","group":"Mobil / Dış Çekim"},{"key":"rgb_background_edge_brand","label":"RGB Fon / Kenar / Marka Rengi","group":"RGB / Kreatif"},{"key":"music_video_color_scene","label":"Müzik Videosu / Renkli Sahne","group":"RGB / Kreatif"},{"key":"projection_gobo_pattern","label":"Projeksiyon / Gobo / Desen Efekti","group":"RGB / Kreatif"},{"key":"studio_key_light","label":"Stüdyo Ana Işığı","group":"Stüdyo / Prodüksiyon"},{"key":"large_softbox_key","label":"Büyük Softbox ile Ana Işık","group":"Stüdyo / Prodüksiyon"},{"key":"film_video_production_key","label":"Film / Video Prodüksiyon Ana Işığı","group":"Stüdyo / Prodüksiyon"},{"key":"technical_product_document_archive","label":"Teknik Ürün / Belge / Arşiv Kaydı","group":"Teknik / Arşiv / Atölye"},{"key":"workshop_handcraft_training","label":"Atölye / El İşi / Masaüstü Eğitim","group":"Teknik / Arşiv / Atölye"},{"key":"diy_how_to","label":"DIY / Nasıl Yapılır?","group":"Teknik / Arşiv / Atölye"}],"panelCatalog":[{"key":"product_ecommerce::small_product_tabletop","label":"Ürün Çekimi / E-Ticaret · Küçük ürün / masaüstü çekim","group":"Ürün Çekimi / E-Ticaret"},{"key":"product_ecommerce::large_product_model","label":"Ürün Çekimi / E-Ticaret · Büyük ürün / model çekimi","group":"Ürün Çekimi / E-Ticaret"},{"key":"product_ecommerce::marketplace_catalog","label":"Ürün Çekimi / E-Ticaret · Pazar yeri / katalog çekimi","group":"Ürün Çekimi / E-Ticaret"},{"key":"youtube_reels_social::single_person_video","label":"YouTube / Reels / Sosyal Medya · Tek kişilik video","group":"YouTube / Reels / Sosyal Medya"},{"key":"youtube_reels_social::reels_tiktok_short","label":"YouTube / Reels / Sosyal Medya · Kısa video / Reels","group":"YouTube / Reels / Sosyal Medya"},{"key":"youtube_reels_social::live_stream_talk","label":"YouTube / Reels / Sosyal Medya · Canlı yayın / konuşma","group":"YouTube / Reels / Sosyal Medya"},{"key":"interview_talking_head::single_interview","label":"Röportaj / Talking Head · Tek kişilik röportaj","group":"Röportaj / Talking Head"},{"key":"interview_talking_head::two_person_interview","label":"Röportaj / Talking Head · İki kişilik röportaj","group":"Röportaj / Talking Head"},{"key":"interview_talking_head::corporate_training","label":"Röportaj / Talking Head · Kurumsal / eğitim videosu","group":"Röportaj / Talking Head"},{"key":"clinic_aesthetic_dental::skin_face_shoot","label":"Klinik / Estetik / Dental · Cilt / yüz çekimi","group":"Klinik / Estetik / Dental"},{"key":"clinic_aesthetic_dental::dental_support","label":"Klinik / Estetik / Dental · Dental destek","group":"Klinik / Estetik / Dental"},{"key":"clinic_aesthetic_dental::clinic_social_content","label":"Klinik / Estetik / Dental · Klinik sosyal medya içeriği","group":"Klinik / Estetik / Dental"},{"key":"rgb_creative_video::background_color_effect","label":"RGB / Kreatif Video · Arka plan renk efekti","group":"RGB / Kreatif Video"},{"key":"rgb_creative_video::music_clip_creative_scene","label":"RGB / Kreatif Video · Müzik klibi / sahne","group":"RGB / Kreatif Video"},{"key":"rgb_creative_video::product_color_separation","label":"RGB / Kreatif Video · Üründe renk ayrıştırma","group":"RGB / Kreatif Video"},{"key":"studio_professional::model_shoot","label":"Stüdyo / Profesyonel · Model çekimi","group":"Stüdyo / Profesyonel"},{"key":"studio_professional::ad_campaign_visual","label":"Stüdyo / Profesyonel · Kampanya / reklam görseli","group":"Stüdyo / Profesyonel"},{"key":"studio_professional::fixed_studio_setup","label":"Stüdyo / Profesyonel · Sabit stüdyo kurulumu","group":"Stüdyo / Profesyonel"},{"key":"mobile_outdoor::battery_shoot","label":"Mobil / Dış Mekan · Bataryalı çekim","group":"Mobil / Dış Mekan"},{"key":"mobile_outdoor::portable_team","label":"Mobil / Dış Mekan · Taşınabilir ekip","group":"Mobil / Dış Mekan"},{"key":"mobile_outdoor::fast_location_setup","label":"Mobil / Dış Mekan · Mekân içi hızlı kurulum","group":"Mobil / Dış Mekan"},{"key":"starter_budget_practical::first_light_choice","label":"Başlangıç / Bütçe / Pratik · İlk ışık seçimi","group":"Başlangıç / Bütçe / Pratik"},{"key":"starter_budget_practical::budget_setup","label":"Başlangıç / Bütçe / Pratik · Bütçe kurulumu","group":"Başlangıç / Bütçe / Pratik"},{"key":"starter_budget_practical::compact_solution","label":"Başlangıç / Bütçe / Pratik · Küçük alan çözümü","group":"Başlangıç / Bütçe / Pratik"}],"cobProducts":{"dx-ml-300c-ii-300w-studyo-tipi-bicolor-surekli-led-video-isigi":{"family":"COB-BICOLOR","lane":"BARE_LIGHT","candidateCount":28,"top":["baby_family_soft_key","large_softbox_key","procedure_technical_closeup","technical_product_document_archive","food_culinary"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","projection_gobo_pattern","film_video_production_key"]},"gdx-300-rgb-iii-profesyonel-fotografcilik-ve-video-renkli-dolgu-isigi":{"family":"COB-RGB","lane":"BARE_LIGHT","candidateCount":33,"top":["rgb_background_edge_brand","large_softbox_key","fashion_model_key","brand_color_live_background","procedure_technical_closeup"],"blocked":["field_interview","travel_vlog_creator","location_portrait_video"]},"gdx-cn-300c-ii-e-ticaret-urun-ve-model-fotograf-cekim-isigi":{"family":"COB-BICOLOR","lane":"BARE_LIGHT","candidateCount":30,"top":["large_softbox_key","dental_closeup_documentation","makeup_beauty","technical_product_document_archive","food_culinary"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene"]},"gdx-cn-300c-ii-ikili-bicolor-isik-seti-roportaj-ve-studyo-kayit-kiti":{"family":"COB-BICOLOR","lane":"SINGLE_READY_SET","candidateCount":29,"top":["catalog_white_background_key","large_softbox_key","dental_closeup_documentation","makeup_beauty","technical_product_document_archive"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","projection_gobo_pattern"]},"gdx-el-300c-ii-300w-profesyonel-video-isik-kaynagi-tekli-kit":{"family":"COB-BICOLOR","lane":"SINGLE_READY_SET","candidateCount":28,"top":["catalog_white_background_key","large_softbox_key","dental_closeup_documentation","makeup_beauty","technical_product_document_archive"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","projection_gobo_pattern","film_video_production_key"]},"gdx-el-300c-ii-studyo-ve-fotograf-cekimi-icin-yuksek-guclu-isik":{"family":"COB-BICOLOR","lane":"BARE_LIGHT","candidateCount":28,"top":["large_softbox_key","dental_closeup_documentation","makeup_beauty","technical_product_document_archive","food_culinary"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","projection_gobo_pattern","film_video_production_key"]},"gdx-exc-180rgb-ii-rgb-led-video-isigi":{"family":"COB-RGB","lane":"BARE_LIGHT","candidateCount":32,"top":["rgb_background_edge_brand","makeup_beauty","clinical_aesthetic_before_after","technical_product_document_archive","brand_color_live_background"],"blocked":["field_interview","travel_vlog_creator","location_portrait_video","film_video_production_key"]},"gdx-exc-220c-ii-bi-color-led-video-isigi":{"family":"COB-BICOLOR","lane":"BARE_LIGHT","candidateCount":30,"top":["baby_family_soft_key","clinical_aesthetic_before_after","technical_product_document_archive","large_softbox_key","food_culinary"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene"]},"gdx-exc-220c-ii-full-set-60x90-softbox-260cm-isik-ayagi":{"family":"COB-BICOLOR","lane":"SINGLE_READY_SET","candidateCount":29,"top":["baby_family_soft_key","reflective_jewelry_glossy","clinical_aesthetic_before_after","technical_product_document_archive","large_softbox_key"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","projection_gobo_pattern"]},"gdx-exc-220c-ii-full-set-gridli-60x90-softbox-260-cm-kalin-isik-ayagi":{"family":"COB-BICOLOR","lane":"SINGLE_READY_SET","candidateCount":29,"top":["baby_family_soft_key","reflective_jewelry_glossy","clinical_aesthetic_before_after","technical_product_document_archive","large_softbox_key"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","projection_gobo_pattern"]},"gdx-exc-600c-ii-650w-bi-color-led-video-surekli-isik-dmx-bowens-mount":{"family":"COB-BICOLOR","lane":"BARE_LIGHT","candidateCount":30,"top":["baby_family_soft_key","large_softbox_key","procedure_technical_closeup","technical_product_document_archive","food_culinary"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene"]},"gdx-exc-600c-ii-profesyonel-youtube-ve-video-icerik-uretim-seti":{"family":"COB-BICOLOR","lane":"SINGLE_READY_SET","candidateCount":29,"top":["baby_family_soft_key","catalog_white_background_key","studio_key_light","procedure_technical_closeup","technical_product_document_archive"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","projection_gobo_pattern"]},"gdx-hd-120ii-c-bicolor-isik":{"family":"COB-BICOLOR","lane":"BARE_LIGHT","candidateCount":24,"top":["baby_family_soft_key","clinical_aesthetic_before_after","technical_product_document_archive","cosmetics_packaging_color","podcast_audio_sensitive"],"blocked":["two_person_interview_key_start","catalog_white_background_key","fashion_model_key","brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","studio_key_light","large_softbox_key","film_video_production_key"]},"gdx-hd-120ii-c-bicolor-tekli-isik-seti-120w-fotograf-ve-video-led-isigi-1":{"family":"COB-BICOLOR","lane":"SINGLE_READY_SET","candidateCount":23,"top":["baby_family_soft_key","reflective_jewelry_glossy","clinical_aesthetic_before_after","technical_product_document_archive","podcast_audio_sensitive"],"blocked":["two_person_interview_key_start","catalog_white_background_key","fashion_model_key","brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","projection_gobo_pattern","studio_key_light","large_softbox_key","film_video_production_key"]},"gdx-lm-300c-ii-300w-bicolor-video-isik-seti-youtube-ve-vlog-produksiyon-kiti":{"family":"COB-BICOLOR","lane":"SINGLE_READY_SET","candidateCount":28,"top":["catalog_white_background_key","large_softbox_key","dental_closeup_documentation","makeup_beauty","technical_product_document_archive"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","projection_gobo_pattern","film_video_production_key"]},"gdx-lm-300c-ii-studyo-ve-fotograf-cekimi-icin-300w-surekli-isik-unitesi":{"family":"COB-BICOLOR","lane":"BARE_LIGHT","candidateCount":28,"top":["large_softbox_key","dental_closeup_documentation","makeup_beauty","technical_product_document_archive","food_culinary"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","projection_gobo_pattern","film_video_production_key"]},"gdx-lv-120c-led-video-isigi":{"family":"COB-BICOLOR","lane":"BARE_LIGHT","candidateCount":27,"top":["baby_family_soft_key","field_interview","clinical_aesthetic_before_after","technical_product_document_archive","cosmetics_packaging_color"],"blocked":["two_person_interview_key_start","catalog_white_background_key","fashion_model_key","brand_color_live_background","rgb_background_edge_brand","music_video_color_scene","studio_key_light","large_softbox_key","film_video_production_key"]},"gdx-lv-led-120c-120w-ultra-sessiz-bi-color-led-cantali-surekli-cob-led-isik-gdx-lv-led-120c-2li-surekli-led-isik-seti-batarya-ve-sarj-cihazi-hediyeli":{"family":"COB-BICOLOR","lane":"BARE_LIGHT","candidateCount":27,"top":["baby_family_soft_key","field_interview","clinical_aesthetic_before_after","technical_product_document_archive","cosmetics_packaging_color"],"blocked":["two_person_interview_key_start","catalog_white_background_key","fashion_model_key","brand_color_live_background","rgb_background_edge_brand","music_video_color_scene","studio_key_light","large_softbox_key","film_video_production_key"]},"gdx-ml-200r-ii-200w-rgb-profesyonel-studyo-ve-urun-cekim-isik-kiti":{"family":"COB-RGB","lane":"SINGLE_READY_SET","candidateCount":31,"top":["reflective_jewelry_glossy","baby_family_soft_key","rgb_background_edge_brand","clinical_aesthetic_before_after","technical_product_document_archive"],"blocked":["field_interview","travel_vlog_creator","location_portrait_video","projection_gobo_pattern","film_video_production_key"]},"gdx-ml-200r-ii-rgb-surekli-isik-200w-profesyonel-video-fotograf-isigi-bowens-mount":{"family":"COB-RGB","lane":"BARE_LIGHT","candidateCount":31,"top":["rgb_background_edge_brand","makeup_beauty","clinical_aesthetic_before_after","technical_product_document_archive","food_culinary"],"blocked":["field_interview","travel_vlog_creator","location_portrait_video","projection_gobo_pattern","film_video_production_key"]},"gdx-ml-300c-ii-bicolor-surekli-isik-seti-300w-profesyonel-video-fotograf-aydinlatma-kiti-softbox-tripod":{"family":"COB-BICOLOR","lane":"SINGLE_READY_SET","candidateCount":28,"top":["baby_family_soft_key","catalog_white_background_key","studio_key_light","procedure_technical_closeup","technical_product_document_archive"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","projection_gobo_pattern","film_video_production_key"]},"gdx-ml150w-bicolor-led-tekli-video-isigi-seti-cantali-bowens-mount-profesyonel-surekli-isik":{"family":"COB-BICOLOR","lane":"SINGLE_READY_SET","candidateCount":28,"top":["baby_family_soft_key","tabletop_small_product","workshop_handcraft_training","clinical_aesthetic_before_after","webinar_online_course"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","projection_gobo_pattern","film_video_production_key"]},"gdx-ml150w-bicolor-led-video-isigi-bowens-mount-profesyonel-surekli-isik":{"family":"COB-BICOLOR","lane":"BARE_LIGHT","candidateCount":29,"top":["baby_family_soft_key","clinical_aesthetic_before_after","technical_product_document_archive","food_culinary","podcast_audio_sensitive"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","film_video_production_key"]},"gdx-ml230w-bicolor-video-led-surekli-isik":{"family":"COB-BICOLOR","lane":"BARE_LIGHT","candidateCount":30,"top":["large_softbox_key","baby_family_soft_key","procedure_technical_closeup","food_culinary","technical_product_document_archive"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene"]},"gdx-ml40rgb-tasinabilir-video-rgb-led-isik":{"family":"COB-RGB","lane":"BARE_LIGHT","candidateCount":24,"top":["rgb_background_edge_brand","travel_vlog_creator","brand_color_live_background","room_natural_background","clinical_aesthetic_before_after"],"blocked":["podcast_audio_sensitive","two_person_interview_key_start","catalog_white_background_key","reflective_jewelry_glossy","cosmetics_packaging_color","fashion_model_key","baby_family_soft_key","dental_closeup_documentation","projection_gobo_pattern","studio_key_light","large_softbox_key","film_video_production_key"]},"gdx-ml60rgb-60w-rgb-bataryali-led-surekli-isik":{"family":"COB-RGB","lane":"BARE_LIGHT","candidateCount":28,"top":["rgb_background_edge_brand","travel_vlog_creator","brand_color_live_background","room_natural_background","clinical_aesthetic_before_after"],"blocked":["podcast_audio_sensitive","two_person_interview_key_start","catalog_white_background_key","fashion_model_key","projection_gobo_pattern","studio_key_light","large_softbox_key","film_video_production_key"]},"godox-la150r-k1-150w-rgb-profesyonel-led-video-aydinlatma-isigi":{"family":"COB-RGB","lane":"BARE_LIGHT","candidateCount":34,"top":["rgb_background_edge_brand","brand_color_live_background","large_softbox_key","makeup_beauty","travel_vlog_creator"],"blocked":["podcast_audio_sensitive","film_video_production_key"]},"godox-la200r-k1-200w-rgb-profesyonel-led-video-aydinlatma-isigi":{"family":"COB-RGB","lane":"BARE_LIGHT","candidateCount":35,"top":["rgb_background_edge_brand","large_softbox_key","brand_color_live_background","location_portrait_video","makeup_beauty"],"blocked":["podcast_audio_sensitive"]},"godox-le200-bicolor-video-led-isik":{"family":"COB-BICOLOR","lane":"BARE_LIGHT","candidateCount":30,"top":["clinical_aesthetic_before_after","makeup_beauty","technical_product_document_archive","cosmetics_packaging_color","large_softbox_key"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene"]},"godox-le200bi-tekli-isik-seti-220w-bicolor-video-led-aydinlatma-kiti-softbox-260cm-tripod":{"family":"COB-BICOLOR","lane":"SINGLE_READY_SET","candidateCount":29,"top":["cosmetics_packaging_color","clinical_aesthetic_before_after","technical_product_document_archive","makeup_beauty","large_softbox_key"],"blocked":["brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","projection_gobo_pattern"]},"godox-sl150r-150w-rgb-profesyonel-led-video-aydinlatma":{"family":"COB-RGB","lane":"BARE_LIGHT","candidateCount":32,"top":["rgb_background_edge_brand","brand_color_live_background","room_natural_background","makeup_beauty","clinical_aesthetic_before_after"],"blocked":["field_interview","travel_vlog_creator","location_portrait_video","film_video_production_key"]},"godox-sl60ii-bi-bi-color-60w-cob-led-video-isigi":{"family":"COB-BICOLOR","lane":"BARE_LIGHT","candidateCount":23,"top":["baby_family_soft_key","clinical_aesthetic_before_after","technical_product_document_archive","food_culinary","podcast_audio_sensitive"],"blocked":["two_person_interview_key_start","catalog_white_background_key","fashion_model_key","brand_color_live_background","field_interview","travel_vlog_creator","location_portrait_video","rgb_background_edge_brand","music_video_color_scene","projection_gobo_pattern","studio_key_light","large_softbox_key","film_video_production_key"]}},"panelProducts":{"gdx-p300ts-bicolor-fotografcilik-ve-studyo-aydinlatmasi-80-watt-led-video-panel-surekli-isik":{"family":"bicolor","candidateCount":24,"top":["clinic_aesthetic_dental::skin_face_shoot","clinic_aesthetic_dental::dental_support","clinic_aesthetic_dental::clinic_social_content","youtube_reels_social::single_person_video","interview_talking_head::single_interview"],"blocked":[]},"gdx-pro-led-gx-300-soft-light-bataryali-led-isik":{"family":"bicolor","candidateCount":24,"top":["mobile_outdoor::portable_team","mobile_outdoor::battery_shoot","mobile_outdoor::fast_location_setup","clinic_aesthetic_dental::dental_support","clinic_aesthetic_dental::skin_face_shoot"],"blocked":[]},"gdx-cf-led-200w-video-led-isik":{"family":"bicolor","candidateCount":24,"top":["product_ecommerce::large_product_model","product_ecommerce::marketplace_catalog","clinic_aesthetic_dental::skin_face_shoot","clinic_aesthetic_dental::dental_support","studio_professional::model_shoot"],"blocked":[]},"gdx-cf-led-120w-video-led-isik":{"family":"bicolor","candidateCount":24,"top":["clinic_aesthetic_dental::skin_face_shoot","clinic_aesthetic_dental::dental_support","product_ecommerce::marketplace_catalog","youtube_reels_social::single_person_video","interview_talking_head::single_interview"],"blocked":[]},"gdx-pro-led-228as-bataryali-surekli-led-isik":{"family":"bicolor","candidateCount":24,"top":["clinic_aesthetic_dental::skin_face_shoot","clinic_aesthetic_dental::dental_support","mobile_outdoor::portable_team","mobile_outdoor::battery_shoot","clinic_aesthetic_dental::clinic_social_content"],"blocked":[]},"godox-ldx50r-rgbww-profesyonel-led-panel-aydinlatma":{"family":"rgb","candidateCount":24,"top":["rgb_creative_video::background_color_effect","mobile_outdoor::battery_shoot","mobile_outdoor::portable_team","mobile_outdoor::fast_location_setup","rgb_creative_video::product_color_separation"],"blocked":[]},"gdx-p-750c-ii-bicolor-canli-yayin-ve-roportaj-isik-kaynagi":{"family":"bicolor","candidateCount":24,"top":["product_ecommerce::large_product_model","product_ecommerce::marketplace_catalog","product_ecommerce::small_product_tabletop","studio_professional::model_shoot","clinic_aesthetic_dental::skin_face_shoot"],"blocked":[]},"gdx-cf-300c-bicolor-led-video-isigi":{"family":"bicolor","candidateCount":24,"top":["clinic_aesthetic_dental::skin_face_shoot","clinic_aesthetic_dental::dental_support","mobile_outdoor::portable_team","mobile_outdoor::battery_shoot","clinic_aesthetic_dental::clinic_social_content"],"blocked":[]},"gdx-cf-led-900w-video-led-isigi":{"family":"bicolor","candidateCount":24,"top":["clinic_aesthetic_dental::skin_face_shoot","clinic_aesthetic_dental::dental_support","interview_talking_head::single_interview","clinic_aesthetic_dental::clinic_social_content","interview_talking_head::two_person_interview"],"blocked":[]},"godox-p260c-pro-bi-color-panel-led-video-isigi":{"family":"bicolor","candidateCount":24,"top":["clinic_aesthetic_dental::skin_face_shoot","clinic_aesthetic_dental::dental_support","mobile_outdoor::portable_team","mobile_outdoor::battery_shoot","mobile_outdoor::fast_location_setup"],"blocked":[]},"gdx-cf-led-1024w-video-led-isik":{"family":"bicolor","candidateCount":24,"top":["clinic_aesthetic_dental::skin_face_shoot","clinic_aesthetic_dental::dental_support","mobile_outdoor::fast_location_setup","mobile_outdoor::portable_team","clinic_aesthetic_dental::clinic_social_content"],"blocked":[]},"gdx-cf-led-1700w-video-led-isigi":{"family":"bicolor","candidateCount":24,"top":["product_ecommerce::large_product_model","clinic_aesthetic_dental::skin_face_shoot","clinic_aesthetic_dental::dental_support","product_ecommerce::marketplace_catalog","mobile_outdoor::portable_team"],"blocked":[]},"gdx-cf-led-2020c-video-led-isik":{"family":"bicolor","candidateCount":24,"top":["clinic_aesthetic_dental::dental_support","clinic_aesthetic_dental::skin_face_shoot","mobile_outdoor::fast_location_setup","interview_talking_head::single_interview","clinic_aesthetic_dental::clinic_social_content"],"blocked":[]},"gdx-cf-led-2020w-video-led-isik":{"family":"daylight_or_fixed_white","candidateCount":24,"top":["clinic_aesthetic_dental::skin_face_shoot","clinic_aesthetic_dental::dental_support","mobile_outdoor::fast_location_setup","mobile_outdoor::portable_team","interview_talking_head::single_interview"],"blocked":[]},"gdx-cf-led-1024w-60w-cri-95-bicolor-led-video-isigi-batarya-ve-sarj-cihazi-hediyeli":{"family":"bicolor","candidateCount":24,"top":["clinic_aesthetic_dental::skin_face_shoot","clinic_aesthetic_dental::dental_support","mobile_outdoor::portable_team","mobile_outdoor::fast_location_setup","mobile_outdoor::battery_shoot"],"blocked":[]},"gdx-p-750r-ii-rgbwy-canli-yayin-ve-podcast-video-isik-sistemi":{"family":"rgb","candidateCount":24,"top":["rgb_creative_video::background_color_effect","rgb_creative_video::product_color_separation","rgb_creative_video::music_clip_creative_scene","studio_professional::ad_campaign_visual","studio_professional::model_shoot"],"blocked":[]},"gdx-cf-1000r-rgb-led-video-isigi":{"family":"rgb","candidateCount":24,"top":["rgb_creative_video::background_color_effect","rgb_creative_video::product_color_separation","rgb_creative_video::music_clip_creative_scene","mobile_outdoor::fast_location_setup","mobile_outdoor::battery_shoot"],"blocked":[]},"gdx-cf-1500r-rgb-led-video-isigi":{"family":"rgb","candidateCount":24,"top":["rgb_creative_video::background_color_effect","rgb_creative_video::product_color_separation","mobile_outdoor::fast_location_setup","rgb_creative_video::music_clip_creative_scene","mobile_outdoor::portable_team"],"blocked":[]},"gdx-cf-led-600rgb-video-led-isik":{"family":"rgb","candidateCount":24,"top":["rgb_creative_video::background_color_effect","rgb_creative_video::product_color_separation","rgb_creative_video::music_clip_creative_scene","mobile_outdoor::battery_shoot","mobile_outdoor::portable_team"],"blocked":[]}},"projectionSha256":"7acfd1cc7c38628152de4968d735c6cad65d09fda2eed54222ec8cbf14fb3cf1"});
  const R13_VERSION=R13_DATA.version;
  const R13_FORBIDDEN=/\b(?:C1S|score cell|ranking engine|frozen manifest|role-mode resolver|canonical geometry)\b/i;

  function r13CatalogMap(rows){
    const m=new Map(); (rows||[]).forEach(x=>m.set(clean(x.key),x)); return m;
  }
  const R13_COB_CATALOG=r13CatalogMap(R13_DATA.cobCatalog);
  const R13_PANEL_CATALOG=r13CatalogMap(R13_DATA.panelCatalog);

  const R13_PDP1_VERSION='CANFOTO-LB2.4-R3-PDP1-NORA-CONTEXT-LANE-PARITY-V1';
  const R13_ELIGIBLE_LANES=new Set(['BARE_LIGHT','SINGLE_READY_SET']);

  function r13PanelContextCompatible(family,row){
    const f=clean(family).toUpperCase();
    const key=clean(row?.key);
    const isRgbFamily=/\bRGB\b/.test(f)||/PANEL-RGB/.test(f);
    if(isRgbFamily) return true;
    /* PDP3: Bi-Color / fixed-white Panel families must not display RGB-only
       creative contexts. This is presentation gating only; canonical Top5 /
       scoring / ranking / setup truth owners remain untouched. */
    if(/^rgb_creative_video::/.test(key)) return false;
    return true;
  }

  function r13FrozenTop5Model(){
    const index=window.CANFOTO_R62HE_FROZEN_INDEX||null;
    const meta=index?.getProduct?.(handle)||null;
    if(!meta || !R13_ELIGIBLE_LANES.has(clean(meta.lane))) return null;

    const kind=clean(meta.engine)==='COB_LED_V5'?'COB':(clean(meta.engine)==='PANEL_LED_V4'?'PANEL':'');
    if(!kind) return null;
    const snapshotApi=kind==='COB'
      ? window.CANFOTO_R62HE_FROZEN_COB_SNAPSHOT
      : window.CANFOTO_R62HE_FROZEN_PANEL_SNAPSHOT;
    const product=snapshotApi?.getProduct?.(handle)||null;
    const rows=Array.isArray(product?.top5)?product.top5:[];
    if(rows.length!==5) return null;

    const priority=rows.map((row,i)=>{
      const n=row?.publicNora||{};
      const purpose=clean(kind==='COB'?n.purposeLabel:n.purposeTitle);
      const sub=clean(kind==='COB'?'':n.subPurposeTitle);
      const group=clean(kind==='COB'?n.mainLabel:n.purposeTitle)||'NORA';
      const label=clean([purpose,sub].filter(Boolean).join(' · '))||clean(n.scenarioLabel)||`NORA kullanım bağlamı ${i+1}`;
      return {
        key:clean(row.selectionKey||row.purposeKey||row.setupRecordId||`${handle}::${i+1}`),
        label,group,
        source:'FROZEN_PRODUCT_TOP5'
      };
    }).filter(x=>x.label);
    if(priority.length!==5) return null;

    const family=clean(meta.familyKey);
    const priorityFiltered=kind==='PANEL'
      ? priority.filter(x=>r13PanelContextCompatible(family,x))
      : priority.slice();
    const priorityKeys=new Set(priorityFiltered.map(x=>clean(x.key)));
    const fullCatalog=kind==='PANEL'
      ? R13_DATA.panelCatalog.map(x=>({key:clean(x.key),label:clean(x.label),group:clean(x.group)}))
      : priorityFiltered.slice();
    const compatible=kind==='PANEL'
      ? fullCatalog.filter(x=>r13PanelContextCompatible(family,x))
      : priorityFiltered.slice();
    const supplemental=kind==='PANEL'
      ? compatible.filter(x=>!priorityKeys.has(clean(x.key)))
      : [];

    return {
      version:'CANFOTO-LB2.4-R3-PDP3-FAMILY-COMPATIBLE-NORA-CONTEXT-V1',
      kind,
      productHandle:handle,
      family,
      lane:clean(meta.lane),
      candidateCount:kind==='PANEL'?compatible.length:priorityFiltered.length,
      priority:priorityFiltered,
      supplemental,
      compatible,
      sourcePriorityCount:priority.length,
      sourceSnapshotSha256:clean(snapshotApi?.sourceArtifactSha256||snapshotApi?.materializationBatchFingerprint),
      projectionSha256:clean(meta.payloadHash),
      projectionMode:kind==='PANEL'
        ? 'FROZEN_PRODUCT_TOP5_PLUS_PANEL_FAMILY_COMPATIBLE_CONTEXT'
        : 'FROZEN_PRODUCT_TOP5_FALLBACK',
      contextParitySource:kind==='PANEL'?'PANEL_CANONICAL_CATALOG_FAMILY_COMPATIBILITY_GATE':'TOP5_ONLY_SOURCE_LIMITED',
      scoringMutation:'NONE',rankingMutation:'NONE',fpMutation:'NONE',productPoolMutation:'NONE',setupTruthMutation:'NONE',commerceMutation:'NONE'
    };
  }

  function r13Model(){
    const cp=R13_DATA.cobProducts[handle]||null;
    const pp=R13_DATA.panelProducts[handle]||null;
    const kind=cp?'COB':(pp?'PANEL':'');
    const p=cp||pp;
    if(!p) return r13FrozenTop5Model();
    const catalog=kind==='COB'?R13_DATA.cobCatalog:R13_DATA.panelCatalog;
    const map=kind==='COB'?R13_COB_CATALOG:R13_PANEL_CATALOG;
    const family=clean(p.family);
    const blocked=new Set((p.blocked||[]).map(clean));
    const compatible=(catalog||[]).filter(x=>!blocked.has(clean(x.key)) && (kind!=='PANEL'||r13PanelContextCompatible(family,x)));
    const topKeys=(p.top||[]).map(clean);
    const priority=topKeys.map(k=>map.get(k)).filter(Boolean).filter(x=>kind!=='PANEL'||r13PanelContextCompatible(family,x));
    const topSet=new Set(priority.map(x=>clean(x.key)));
    const supplemental=compatible.filter(x=>!topSet.has(clean(x.key)));
    return {
      version:kind==='PANEL'?'CANFOTO-LB2.4-R3-PDP3-FAMILY-COMPATIBLE-NORA-CONTEXT-V1':R13_VERSION,kind,productHandle:handle,family,lane:clean(p.lane),
      candidateCount:kind==='PANEL'?compatible.length:Number(p.candidateCount||0),priority,supplemental,compatible,sourcePriorityCount:topKeys.length,
      sourceSnapshotSha256:kind==='COB'?R13_DATA.source.cobSnapshotSha256:R13_DATA.source.panelSnapshotSha256,
      projectionSha256:R13_DATA.projectionSha256,
      projectionMode:kind==='PANEL'?'R13_EXISTING_SOURCE_BACKED_PROJECTION_PLUS_FAMILY_COMPATIBILITY_GATE':'R13_EXISTING_SOURCE_BACKED_PROJECTION',
      scoringMutation:'NONE',rankingMutation:'NONE',fpMutation:'NONE',productPoolMutation:'NONE',setupTruthMutation:'NONE',commerceMutation:'NONE'
    };
  }

  function r13EnsureContainer(){
    const old=q('[data-cf85-nora-context]');
    if(!old) return null;
    if(old.matches('[data-cf-r13-context-root]')) return old;
    const box=document.createElement('div');
    box.className='cf-r13-nora-context';
    box.dataset.cf85NoraContext='';
    box.dataset.cfR13ContextRoot='';
    old.replaceWith(box);
    return box;
  }

  function r13SetOwnerVisible(show){
    const owner=q('[data-cf85-nora-context-owner]');
    const toggle=q('[data-cf85-nora-toggle]');
    const panel=q('[data-cf85-nora-panel]');
    if(!owner) return;

    const visible=!!show;
    owner.hidden=!visible;
    owner.dataset.cf85NoraAvailability=visible?'AVAILABLE':'UNAVAILABLE_FAIL_CLOSED';

    if(!visible){
      if(toggle) toggle.setAttribute('aria-expanded','false');
      if(panel) panel.hidden=true;
    }
  }

  function r13BindToggle(){
    const toggle=q('[data-cf85-nora-toggle]');
    const panel=q('[data-cf85-nora-panel]');
    if(!toggle||!panel||toggle.dataset.cf85Bound==='1') return;
    toggle.dataset.cf85Bound='1';

    toggle.addEventListener('click',()=>{
      const open=toggle.getAttribute('aria-expanded')==='true';
      toggle.setAttribute('aria-expanded',open?'false':'true');
      panel.hidden=open;
      toggle.dataset.cf85NoraState=open?'CLOSED':'OPEN';
    });
  }

  function r13Render(){
    const model=r13Model();
    const hasNoraSetup=!!(
      model &&
      Array.isArray(model.priority) &&
      model.priority.length>0
    );

    if(!hasNoraSetup){
      r13SetOwnerVisible(false);
      window.CANFOTO_E1_F10_R13_NORA_CONTEXT=Object.freeze({
        status:'UNAVAILABLE',
        productHandle:handle,
        reason:'NO_FROZEN_NORA_SETUP_CONTEXT',
        scoringMutation:'NONE',
        rankingMutation:'NONE',
        fpMutation:'NONE',
        productPoolMutation:'NONE',
        setupTruthMutation:'NONE',
        commerceMutation:'NONE'
      });
      return null;
    }

    const box=r13EnsureContainer();
    if(!box){
      r13SetOwnerVisible(false);
      return null;
    }
    box.replaceChildren();
    box.dataset.cfR13Version=model.version;
    box.dataset.cfR13Engine=model.kind;
    box.dataset.cfR13CandidateCount=String(model.candidateCount);
    box.dataset.cfR13PriorityCount=String(model.priority.length);
    box.dataset.cfR13SupplementalCount=String(model.supplemental.length);
    box.dataset.cfR13Source=clean(model.projectionMode)||'READONLY_CANONICAL_CONTEXT_PROJECTION';

    const lead=document.createElement('div'); lead.className='cf-r13-context-lead';
    const leadTitle=document.createElement('strong'); leadTitle.textContent='Öne çıkan kullanım alanları';
    const leadCopy=document.createElement('span'); leadCopy.textContent='Ürünün kurulum verileriyle doğrulanan öncelikli çekim bağlamları.';
    lead.append(leadTitle,leadCopy); box.append(lead);

    const top=document.createElement('div'); top.className='cf-r13-context-chips cf-r13-context-chips--priority';
    model.priority.forEach(row=>{
      const el=document.createElement('span');
      el.className='cf-r13-context-chip cf-r13-context-chip--priority';
      el.dataset.cfR13Key=clean(row.key); el.dataset.cfR13Source=model.kind+'_FROZEN_TOP5';
      el.textContent=clean(row.label); top.append(el);
    });
    box.append(top);

    if(model.supplemental.length){
      const more=document.createElement('div'); more.className='cf-r13-context-more';
      const h=document.createElement('strong'); h.className='cf-r13-context-more-title';
      h.textContent=`Diğer doğrulanmış kullanım alanları (${model.supplemental.length})`; more.append(h);
      const groups=new Map();
      model.supplemental.forEach(row=>{
        const g=clean(row.group)||'Diğer kullanım alanları';
        if(!groups.has(g)) groups.set(g,[]); groups.get(g).push(row);
      });
      const grid=document.createElement('div'); grid.className='cf-r13-context-groups';
      groups.forEach((rows,label)=>{
        const section=document.createElement('section'); section.className='cf-r13-context-group';
        const gh=document.createElement('b'); gh.textContent=label; section.append(gh);
        const list=document.createElement('ul');
        rows.forEach(row=>{
          const li=document.createElement('li'); li.dataset.cfR13Key=clean(row.key); li.dataset.cfR13Source=model.kind+'_CANONICAL_COMPATIBLE';
          li.textContent=clean(row.label).replace(new RegExp('^'+label.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+'\\s*[·—-]\\s*','i'),'');
          list.append(li);
        });
        section.append(list); grid.append(section);
      });
      more.append(grid); box.append(more);
    }

    const customerText=clean(box.textContent||'');
    if(R13_FORBIDDEN.test(customerText)){
      box.dataset.cfR13PublicCopy='FAIL_CLOSED';
      box.replaceChildren();
      r13SetOwnerVisible(false);
      return null;
    }

    box.dataset.cfR13PublicCopy='PASS';
    r13SetOwnerVisible(true);
    r13BindToggle();
    window.CANFOTO_E1_F10_R13_NORA_CONTEXT=Object.freeze({...model,status:'READY',publicCopy:'PASS'});
    return model;
  }

  /* ========================================================
     PDP DECISION COPY R1 · SOURCE SUMMARY + CONTINUATION
     - Prefer Shopify SEO description when explicitly present.
     - Otherwise derive a sentence-aware preview from the full
       source product description and expose the remainder through
       a native <details> "Devamını oku…" disclosure.
     - No scoring/ranking/setup truth mutation.
     ======================================================== */
  const PDP2_DECIMAL_TOKEN='\uE000';

  function decisionSentenceParts(raw){
    const protectedText=clean(raw).replace(/(\d)\.(?=\d)/g,`$1${PDP2_DECIMAL_TOKEN}`);
    const parts=protectedText.match(/[^.!?…]+[.!?…]+|[^.!?…]+$/g)||[protectedText];
    return parts.map(x=>clean(x).replaceAll(PDP2_DECIMAL_TOKEN,'.')).filter(Boolean);
  }

  function decisionSplit(raw,maxWords=72,minSentenceWords=42){
    const text=clean(raw);
    if(!text) return {preview:'',rest:''};
    const parts=decisionSentenceParts(text);
    const words=text.split(' ').filter(Boolean);
    if(words.length<=maxWords) return {preview:text,rest:''};

    let previewParts=[], count=0;
    for(const part of parts){
      const n=part.split(' ').filter(Boolean).length;
      if(count+n>maxWords && count>=minSentenceWords) break;
      previewParts.push(part); count+=n;
      if(count>=maxWords) break;
    }
    if(!previewParts.length){
      previewParts=[words.slice(0,maxWords).join(' ')];
      count=maxWords;
    }
    const preview=clean(previewParts.join(' '));
    const rest=clean(text.slice(preview.length));
    return {preview,rest};
  }

  const PDP1_CANONICAL_CLOSE='Ürünü, kullanım ihtiyacınıza göre teknik özellikleri ve paket içeriğiyle birlikte değerlendirin.';
  const PDP1_LOW_QUALITY_TAIL=/\b(?:derim|hemen|şimdi|burada|keşfedin|keşfedilmeli|yakala(?:yın)?|başlayın|bekliyor)\b/gi;

  function decisionCopySanitize(raw){
    const text=clean(raw).replace(/!{2,}/g,'!').replace(/\?{2,}/g,'?');
    if(!text) return {text:'',changed:false,reason:''};
    const parts=decisionSentenceParts(text);
    const last=clean(parts[parts.length-1]||'');
    const matches=last.match(PDP1_LOW_QUALITY_TAIL)||[];
    PDP1_LOW_QUALITY_TAIL.lastIndex=0;
    const repeated=/(?:\b(hemen|şimdi|burada|keşfedin|keşfedilmeli)\b)(?:.*\b\1\b)/i.test(last);
    const malformed=/\bderim\b/i.test(last)||/\btam\s+(?:şu\s+an|da\s+burada)\b/i.test(last);
    const templatedCta=/\b(?:hemen|şimdi|burada|keşfedilmeli)\b/i.test(last)||/\bsizi\s+bekliyor\b/i.test(last);
    const hypeTail=matches.length>=2||repeated||malformed||templatedCta||/[!]{2,}$/.test(clean(raw));
    if(!hypeTail) return {text,changed:text!==clean(raw),reason:text!==clean(raw)?'PUNCTUATION_NORMALIZED':''};

    const kept=parts.slice(0,-1).map(clean).filter(Boolean);
    const safe=[...kept,PDP1_CANONICAL_CLOSE].join(' ').replace(/\s+/g,' ').trim();
    return {text:safe,changed:true,reason:'LOW_QUALITY_PROMOTIONAL_TAIL_REPLACED_DECIMAL_SAFE'};
  }

  function fillDecisionSummary(){
    const lead=q('[data-cf85-decision-lead]');
    const host=q('[data-cf85-decision-more-host]');
    if(!lead||!host) return;

    const seo=clean(source.seoDescription);
    const body=clean(source.descriptionText);
    const sourceText=seo||body;

    host.replaceChildren();
    host.hidden=true;
    delete host.dataset.cf85DecisionContinuation;

    if(!sourceText){
      lead.textContent='Ürünün doğrulanmış açıklaması için aşağıdaki gerçek ürün açıklaması bölümünü inceleyin.';
      lead.dataset.cf85DecisionSource='EMPTY_FAIL_CLOSED';
      return;
    }

    if(seo){
      const normalized=decisionCopySanitize(seo);
      lead.textContent=normalized.text||seo;
      lead.dataset.cf85DecisionSource=normalized.changed?'SHOPIFY_SEO_DESCRIPTION_SANITIZED':'SHOPIFY_SEO_DESCRIPTION_FULL';
      lead.dataset.cf85DecisionSanitizer=PDP1_CANONICAL_CLOSE;
      if(normalized.reason) lead.dataset.cf85DecisionSanitizerReason=normalized.reason;
      else delete lead.dataset.cf85DecisionSanitizerReason;
      return;
    }

    // Q PDP PILOT V1: the complete description is rendered in #urun-aciklamasi.
    // Show a short decision summary, never a second full continuation copy.
    const split=decisionSplit(body);
    lead.textContent=split.preview||body;
    lead.dataset.cf85DecisionSource='SHOPIFY_BODY_SUMMARY_ONLY';
    host.replaceChildren();
    host.hidden=true;
  }

  function fillSourcePanels(){
    const t=productTruth();
    const warranty=/GDX/i.test(clean(source.vendor))?'5 YIL':(/Godox/i.test(clean(source.vendor))?'2 YIL':'Ürün kaynağı');
    const spec={
      family:t.family||clean(source.productType)||'Ürün',
      power:t.power||'',
      kelvin:t.kelvin||'',
      cri:t.cri||'',
      control:t.control||'',
      warranty:t.warranty||(warranty==='Ürün kaynağı'?'':warranty)
    };
    Object.entries(spec).forEach(([k,v])=>{
      const el=q(`[data-cf85-spec="${k}"]`);
      if(!el) return;
      el.textContent=v;
      const card=el.closest('.pdp-spec-card');
      if(!card) return;
      const mustResolve=['power','kelvin','cri','control','warranty'].includes(k);
      if(mustResolve && !v){
        card.hidden=true;
        card.setAttribute('aria-hidden','true');
        card.dataset.cf85Suppressed='UNRESOLVED_FAIL_CLOSED_R6';
      }else{
        card.hidden=false;
        card.removeAttribute('aria-hidden');
        delete card.dataset.cf85Suppressed;
      }
    });
    const controlEl=q('[data-cf85-spec="control"]');
    const controlLabel=controlEl?.closest('.pdp-spec-card')?.querySelector('span');
    if(controlEl && t.control && controlLabel) controlLabel.textContent=t.controlLabel||'Kontrol / Montaj';

    const summary=[spec.power,spec.kelvin,spec.cri,spec.control].filter(Boolean).join(' · ');
    const tech=q('[data-cf85-technical-summary]');
    if(tech) tech.textContent=summary||'Doğrulanmış teknik bilgiler ürün açıklamasında yer alır.';

    fillDecisionSummary();

    const top=t.top5Purposes||[];
    const benefits=qa('[data-cf85-benefit]');
    benefits.forEach((el,i)=>{
      const label=top[i];
      if(!label){el.hidden=true;return;}
      el.hidden=false;
      q('b',el).textContent=label;
      q('p',el).textContent=i===0
        ? (t.role||'Bu kullanım, ürünün öne çıkan çekim senaryoları arasındadır.')
        : (i===1?(t.creative||'Bu kullanım, ürünün öne çıkan çekim senaryoları arasındadır.'):'Bu kullanım, ürünün öne çıkan çekim senaryoları arasındadır.');
    });

    if(!SOURCE_FACTS) SOURCE_FACTS=extractSourceFacts();
    const packageSummary=(SOURCE_FACTS?.packageItems||[]).join(' · ');
    window.CANFOTO_Y_PDP_SOURCE_FACTS_R1_QA=()=>({version:'CANFOTO-Y-PDP-SOURCE-FACTS-R1',product:clean(source.title),technicalRows:Object.entries(SOURCE_FACTS?.rows||{}),packageItems:[...(SOURCE_FACTS?.packageItems||[])],packageDiagnostic:SOURCE_FACTS?.diagnostic||null,technicalSummary:summary,productType:clean(source.productType)});
    const packageDetails=[...document.querySelectorAll('.pdp-details-list details')].find(d=>/Paket|kutu/i.test(textNorm(d.querySelector('summary')?.textContent||'')));
    const packageP=packageDetails?.querySelector('p');
    if(packageP && packageSummary) packageP.textContent=packageSummary;

    r13Render();

    /* Sealed REV85 buybox has two truth cells:
       effective product power/role + product family.
       Native Inventory remains the stock owner, so do not duplicate stock here. */
    const trust=q('[data-canfoto-rev85-trust-row]');
    if(trust){
      const cells=[...trust.children].filter(x=>x.nodeType===1);
      if(cells[0]){
        const b=q('b',cells[0]), s=q('span',cells[0]);
        if(b) b.textContent=spec.power||(source.vendor||'CAN FOTO');
        if(s) s.textContent=spec.family||'Ürün';
      }
      if(cells[1]){
        const b=q('b',cells[1]), s=q('span',cells[1]);
        if(b) b.textContent=spec.family||clean(source.productType)||'Ürün';
        if(s) s.textContent='Ürün ailesi';
      }
      cells.slice(2).forEach(x=>x.remove());
      trust.dataset.cf85OracleCells='2';
    }

    const avail=q('[data-canfoto-rev85-availability]');
    if(avail) avail.textContent=source.variant?.available?'STOKTA':'STOK DIŞI';
  }

  function nativeSelectedVariant(formId){
    const form=document.getElementById(formId);
    if(!form) return null;
    const id=form.querySelector('input[name="id"]')?.value;
    const qty=form.querySelector('input[name="quantity"]')?.value
      || q(`[form="${CSS.escape(formId)}"][name="quantity"]`)?.value
      || 1;
    const n=Math.max(1,parseInt(qty,10)||1);
    return id?{id:String(id),qty:n}:null;
  }

  function bindBuyNow(){
    qa('[data-canfoto-rev85-buy-now]').forEach(btn=>{
      if(btn.dataset.cf85Bound==='1') return;
      btn.dataset.cf85Bound='1';
      btn.addEventListener('click',()=>{
        if(btn.disabled) return;
        const formId=clean(btn.dataset.productForm);
        const selected=nativeSelectedVariant(formId);
        if(!selected) return;
        const root=window.Shopify?.routes?.root||'/';
        location.href=`${root}cart/${encodeURIComponent(selected.id)}:${selected.qty}?checkout`;
      });
    });
  }

  function moveMirrorButton(){
    const root=q('[data-nora-pdp-setup]');
    if(!root) return false;
    const schema=q('.nps-schema',root);
    const btn=q('[data-nps-mirror],.nps-mirror-btn',root);
    if(!schema||!btn) return false;

    let band=q('.nps-mirror-band',root);
    if(!band){
      band=document.createElement('div');
      band.className='nps-mirror-band';
      band.dataset.cf85MirrorBand='1';
    }

    /* R2 ROOT-CAUSE FIX
       .nps-main-grid has exactly two layout children: .nps-schema + .nps-side.
       R1 inserted the mirror band AFTER .nps-schema, accidentally creating a
       third CSS-grid item and pushing .nps-side to the next grid cell/row.
       The locked requirement is "immediately below the schematic", therefore
       the band belongs INSIDE .nps-schema, after its legend, not as a sibling
       of .nps-schema. */
    const legend=q('.nps-legend',schema);
    if(band.parentElement!==schema){
      if(legend) legend.insertAdjacentElement('afterend',band);
      else schema.appendChild(band);
    }else if(legend && legend.nextElementSibling!==band){
      legend.insertAdjacentElement('afterend',band);
    }

    if(btn.parentElement!==band) band.appendChild(btn);

    root.dataset.cf85MirrorPlacement='SCHEMA_INTERNAL';
    return true;
  }

  function supportBehavior(){
    const toggle=q('[data-cf14-hayyam-toggle]');
    const panel=q('[data-cf14-hayyam-panel]');
    if(toggle&&panel&&!toggle.dataset.cf85Bound){
      toggle.dataset.cf85Bound='1';
      toggle.addEventListener('click',()=>{
        const open=toggle.getAttribute('aria-expanded')!=='true';
        toggle.setAttribute('aria-expanded',String(open));
        panel.hidden=!open;
      });
    }

    const modal=q('#cf14FaqModal');
    const open=q('[data-cf14-faq-open]');
    const close=q('[data-cf14-faq-close]');
    const setModal=on=>{
      if(!modal)return;
      modal.setAttribute('aria-hidden',String(!on));
      document.documentElement.style.overflow=on?'hidden':'';
      if(on) close?.focus({preventScroll:true});
      else open?.focus({preventScroll:true});
    };
    if(open&&!open.dataset.cf85Bound){
      open.dataset.cf85Bound='1'; open.addEventListener('click',()=>setModal(true));
      close?.addEventListener('click',()=>setModal(false));
      modal?.addEventListener('click',e=>{if(e.target===modal)setModal(false)});
      addEventListener('keydown',e=>{if(e.key==='Escape'&&modal?.getAttribute('aria-hidden')==='false')setModal(false)});
    }
  }

  function hideLegacyDuplicateFaq(){
    qa('[id*="__custom_liquid_QDTjjH"],[id*="__custom_liquid_FxbBL4"]').forEach(x=>x.hidden=true);
  }



  /* R6 — read-only presentation family bridge.
     The final REV27 oracle uses family-aware hero occupancy. If the sealed
     runtime already owns the family flag we preserve it; otherwise we derive
     only the presentation flag from the existing NORA config. */
  function syncPresentationFamily(){
    if(document.body.dataset.canfotoPdpV5Family) return document.body.dataset.canfotoPdpV5Family;
    const cfgNode=q('.nora-pdp-config');
    let fam='';
    try{ fam=clean(JSON.parse(cfgNode?.textContent||'{}')?.family).toUpperCase(); }catch(_){ fam=''; }
    const map=[
      [/PANEL.*RGB|RGB.*PANEL/,'PANEL-RGB'],
      [/PANEL.*BI|BI.*PANEL/,'PANEL-BICOLOR'],
      [/RGB.*FX|FX.*RGB/,'RGB-FX'],
      [/COB.*RGB|RGB.*COB/,'COB-RGB'],
      [/COB.*BI|BI.*COB|BI-COLOR/,'COB-BICOLOR']
    ];
    const hit=map.find(([re])=>re.test(fam));
    if(hit) document.body.dataset.canfotoPdpV5Family=hit[1];
    return document.body.dataset.canfotoPdpV5Family||'';
  }

  /* R6 keeps the sealed REV85 V18 desktop source-image modal behavior,
     but also re-binds after any Shopify/source DOM refresh so the physical
     behavior cannot silently disappear after initial boot. */
  const CF18_MQ=window.matchMedia('(min-width: 901px)');
  const CF18_SELECTOR='.pdp-source-description .pdp-source-feature>img,.pdp-source-description .pdp-source-card>img,.pdp-source-description .pdp-source-tech__media>img,.pdp-source-description .cf-owned-description img';
  let CF18_MODAL=null,CF18_LAST_TRIGGER=null,CF18_BOUND=[];
  function cf18MakeModal(){
    if(CF18_MODAL && document.contains(CF18_MODAL)) return CF18_MODAL;
    const existing=qa('.cf18-source-image-modal');
    let modal=existing[0]||null;
    existing.slice(1).forEach(x=>x.remove());
    if(!modal){
      modal=document.createElement('div');
      modal.className='cf18-source-image-modal';
      modal.hidden=true;
      modal.setAttribute('role','presentation');
      modal.innerHTML='<div class="cf18-source-image-modal__panel" role="dialog" aria-modal="true" aria-label="Ürün açıklaması görseli"><button class="cf18-source-image-modal__close" type="button" aria-label="Görseli kapat">×</button><div class="cf18-source-image-modal__stage"><img alt=""></div><div class="cf18-source-image-modal__caption"><strong>Ürün açıklaması görseli</strong><span></span></div></div>';
      document.body.appendChild(modal);
    }
    modal.dataset.cf18Owner='R7_SINGLE_OWNER';
    if(modal.dataset.cf18EventsBound!=='true'){
      modal.dataset.cf18EventsBound='true';
      q('.cf18-source-image-modal__close',modal)?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();cf18Close();});
      modal.addEventListener('click',e=>{if(e.target===modal)cf18Close();});
      q('.cf18-source-image-modal__panel',modal)?.addEventListener('click',e=>e.stopPropagation());
    }
    if(!window.__CANFOTO_CF18_ESC_BOUND__){
      window.__CANFOTO_CF18_ESC_BOUND__=true;
      document.addEventListener('keydown',e=>{if(CF18_MODAL&&!CF18_MODAL.hidden&&e.key==='Escape'){e.preventDefault();cf18Close();}});
    }
    CF18_MODAL=modal;
    return modal;
  }
  function cf18Open(img){
    if(!CF18_MQ.matches||!img) return false;
    const modal=cf18MakeModal();
    const target=q('.cf18-source-image-modal__stage img',modal);
    const cap=q('.cf18-source-image-modal__caption span',modal);
    CF18_LAST_TRIGGER=img;
    target.src=img.currentSrc||img.src||'';
    target.alt=img.alt||'Ürün açıklaması görseli';
    if(cap) cap.textContent=img.alt||'Ürün açıklamasından görsel';
    modal.hidden=false;
    document.documentElement.classList.add('cf18-modal-open');
    document.body.classList.add('cf18-modal-open');
    requestAnimationFrame(()=>q('.cf18-source-image-modal__close',modal)?.focus({preventScroll:true}));
    return true;
  }
  function cf18Close(){
    if(!CF18_MODAL||CF18_MODAL.hidden) return;
    CF18_MODAL.hidden=true;
    document.documentElement.classList.remove('cf18-modal-open');
    document.body.classList.remove('cf18-modal-open');
    if(CF18_LAST_TRIGGER&&document.contains(CF18_LAST_TRIGGER)) CF18_LAST_TRIGGER.focus({preventScroll:true});
    CF18_LAST_TRIGGER=null;
  }
  function cf18Activate(img){
    if(!img||img.dataset.cf18Bound==='true') return;
    img.dataset.cf18Bound='true';
    img.dataset.cf18Zoomable='true';
    img.tabIndex=0;
    img.setAttribute('role','button');
    img.setAttribute('aria-label',`${img.alt||'Ürün açıklaması görseli'} · büyüt`);
    const click=e=>{e?.preventDefault?.();e?.stopPropagation?.();cf18Open(img);};
    const key=e=>{if((e.key==='Enter'||e.key===' ')&&CF18_MQ.matches){e.preventDefault();e.stopPropagation();cf18Open(img);}};
    img.addEventListener('click',click);
    img.addEventListener('keydown',key);
    CF18_BOUND.push([img,click,key]);
  }
  function cf18Deactivate(){
    cf18Close();
    CF18_BOUND.forEach(([img,click,key])=>{img.removeEventListener('click',click);img.removeEventListener('keydown',key);delete img.dataset.cf18Bound;delete img.dataset.cf18Zoomable;img.removeAttribute('role');img.removeAttribute('aria-label');img.removeAttribute('tabindex');});
    CF18_BOUND=[];
  }
  function cf18Sync(){ if(CF18_MQ.matches) qa(CF18_SELECTOR).forEach(cf18Activate); else cf18Deactivate(); }
  if(CF18_MQ.addEventListener) CF18_MQ.addEventListener('change',cf18Sync); else CF18_MQ.addListener(cf18Sync);

  let CF18_OBSERVER=null;
  function cf18ObserveSource(){
    const root=q('#urun-aciklamasi');
    if(!root||CF18_OBSERVER) return;
    let queued=false;
    CF18_OBSERVER=new MutationObserver(()=>{
      if(queued) return; queued=true;
      requestAnimationFrame(()=>{queued=false;cf18Sync();cf19Sync();});
    });
    CF18_OBSERVER.observe(root,{childList:true,subtree:true});
  }


/* LB2.4-R3-PDP4: mobile source accordion copy-only close; PDP3 NORA truth remains no-touch. */
  /* ========================================================
     R9 · EXACT SEALED PDP-V19 MOBILE INFORMATION ACCORDIONS
     <=720 only. Desktop >=721 is structurally no-touch.
     ======================================================== */
  const CF19_MQ=window.matchMedia('(max-width: 720px)');
  const CF19_RECORDS=[];
  const CF19_DEFS=[
    {kind:'benefits',selector:'.pdp-detail-panel:not(.pdp-details-list)',label:'ÇEKİMİNİZE NE KATAR?',hint:'Çekim avantajlarını göster'},
    {kind:'source',selector:'.pdp-source-description',label:'AÇIKLAMA | GÖRSELLER',hint:'Ürün açıklamasını ve görselleri göster'}
  ];
  function cf19LabelText(el){return clean(el?.textContent||'').toLocaleUpperCase('tr-TR')}
  function cf19FindTarget(def){
    if(def.kind==='source') return q(def.selector);
    return qa(def.selector).find(el=>{
      const lab=q(':scope > .shop-label',el);
      return cf19LabelText(lab)===def.label;
    })||null;
  }
  function cf19MakeButton(def,id){
    const btn=document.createElement('button');
    btn.type='button';
    btn.className='cf19-pdp-mobile-acc-trigger';
    btn.setAttribute('aria-expanded','false');
    btn.setAttribute('aria-controls',id);
    btn.innerHTML=`<span><span class="cf19-pdp-mobile-acc-title">${def.label}</span><span class="cf19-pdp-mobile-acc-hint">${def.hint}</span></span><span class="cf19-pdp-mobile-acc-icon" aria-hidden="true">⌄</span>`;
    return btn;
  }
  function cf19CloseRoot(root,trigger,focus=true){
    root.classList.remove('is-open');
    trigger.setAttribute('aria-expanded','false');
    if(focus){
      trigger.focus({preventScroll:true});
      trigger.scrollIntoView({behavior:'smooth',block:'center'});
    }
  }
  function cf19Mount(def){
    const root=cf19FindTarget(def);
    if(!root||root.dataset.cf19MobileAccordion==='1') return false;
    root.dataset.cf19MobileAccordion='1';
    root.classList.add('cf19-pdp-mobile-acc',`cf19-pdp-mobile-acc--${def.kind}`);
    const original=[...root.childNodes];
    const detailStates=qa('details',root).map(d=>({el:d,open:d.open}));
    const id=`cf19-${def.kind}-${Math.random().toString(36).slice(2,8)}`;
    const trigger=cf19MakeButton(def,id);
    const panel=document.createElement('div');
    panel.className='cf19-pdp-mobile-acc-panel';
    panel.id=id;
    panel.setAttribute('role','region');
    panel.setAttribute('aria-label',def.label);
    const inner=document.createElement('div');
    inner.className='cf19-pdp-mobile-acc-panel-inner';
    const content=document.createElement('div');
    content.className='cf19-pdp-mobile-acc-content';
    original.forEach(n=>content.appendChild(n));
    const closeBtn=document.createElement('button');
    closeBtn.type='button';
    closeBtn.className='cf19-pdp-mobile-acc-close';
    closeBtn.innerHTML='<span>Kapat</span><span aria-hidden="true">↑</span>';
    content.appendChild(closeBtn);
    inner.appendChild(content);
    panel.appendChild(inner);
    root.append(trigger,panel);
    trigger.addEventListener('click',()=>{
      const open=root.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded',open?'true':'false');
    });
    closeBtn.addEventListener('click',()=>cf19CloseRoot(root,trigger,true));
    CF19_RECORDS.push({root,trigger,panel,content,original,detailStates});
    return true;
  }
  function cf19UnmountAll(){
    while(CF19_RECORDS.length){
      const r=CF19_RECORDS.pop();
      r.detailStates.forEach(x=>x.el.open=x.open);
      r.original.forEach(n=>r.root.appendChild(n));
      r.trigger.remove();
      r.panel.remove();
      r.root.classList.remove(
        'cf19-pdp-mobile-acc',
        'cf19-pdp-mobile-acc--benefits',
        'cf19-pdp-mobile-acc--info',
        'cf19-pdp-mobile-acc--source',
        'is-open'
      );
      delete r.root.dataset.cf19MobileAccordion;
    }
  }
  let CF19_INFO_OBSERVER=null;
  const CF19_INFO_SETTLE_TIMERS=[];
  function cf19BindProductInfoDetail(d){
    if(!d||d.dataset.cf19ResponsiveBound==='1') return;
    d.dataset.cf19ResponsiveBound='1';
    const summary=q(':scope > summary',d);
    if(!summary) return;
    const markTouched=()=>{d.dataset.cf19UserTouched='1';};
    summary.addEventListener('pointerdown',markTouched,{passive:true});
    summary.addEventListener('keydown',e=>{
      if(e.key==='Enter'||e.key===' ') markTouched();
    });
  }
  function cf19ApplyProductInfoDefault(d,mobile,resetTouch=false){
    if(!d) return;
    cf19BindProductInfoDetail(d);
    if(resetTouch) delete d.dataset.cf19UserTouched;
    const summaryText=clean(q(':scope > summary',d)?.textContent||'');
    const isNoraContext=/NORA\s+kullanım\s+bağlamı/i.test(summaryText);
    const mode=mobile?'MOBILE_CLOSED':(isNoraContext?'DESKTOP_NORA_CONTEXT_CLOSED':'DESKTOP_OPEN');
    d.dataset.cf19ResponsiveDefault=mode;
    if(isNoraContext) d.dataset.cfR13DesktopDefault='CLOSED';
    else delete d.dataset.cfR13DesktopDefault;
    if(d.dataset.cf19UserTouched!=='1'){
      const targetOpen=mobile?false:!isNoraContext;
      if(d.open!==targetOpen) d.open=targetOpen;
    }
  }
  function cf19EnsureProductInfoObserver(info){
    if(!info||CF19_INFO_OBSERVER) return;
    CF19_INFO_OBSERVER=new MutationObserver(mutations=>{
      const mobile=CF19_MQ.matches;
      mutations.forEach(m=>{
        const d=m.target;
        if(!(d instanceof HTMLDetailsElement)) return;
        if(d.dataset.cf19UserTouched==='1') return;
        cf19ApplyProductInfoDefault(d,mobile,false);
      });
    });
    CF19_INFO_OBSERVER.observe(info,{subtree:true,attributes:true,attributeFilter:['open']});
  }
  function cf19SyncProductInfoDetails(resetTouch=false){
    const mobile=CF19_MQ.matches;
    const info=q('.pdp-detail-panel.pdp-details-list');
    const details=qa('.pdp-detail-panel.pdp-details-list details');
    details.forEach(d=>cf19ApplyProductInfoDefault(d,mobile,resetTouch));
    if(info){
      info.hidden=false;
      info.removeAttribute('aria-hidden');
      info.dataset.cf19ResponsiveInfo=mobile?'MOBILE_VISIBLE_DETAILS_CLOSED':'DESKTOP_VISIBLE_NORA_CONTEXT_CLOSED_OTHERS_OPEN';
      info.dataset.cf19ResponsiveOwner='CANFOTO_E1_F10_R91';
      cf19EnsureProductInfoObserver(info);
    }
  }
  function cf19ScheduleProductInfoSettle(){
    while(CF19_INFO_SETTLE_TIMERS.length) clearTimeout(CF19_INFO_SETTLE_TIMERS.pop());
    [0,80,240,700].forEach(delay=>{
      CF19_INFO_SETTLE_TIMERS.push(setTimeout(()=>cf19SyncProductInfoDetails(false),delay));
    });
  }
  function cf19Sync(resetTouch=false){
    if(CF19_MQ.matches) CF19_DEFS.forEach(cf19Mount);
    else cf19UnmountAll();
    cf19SyncProductInfoDetails(resetTouch);
    cf19ScheduleProductInfoSettle();
    document.body.dataset.canfotoPdpV19='true';
  }
  const cf19ViewportChange=()=>cf19Sync(true);
  if(CF19_MQ.addEventListener) CF19_MQ.addEventListener('change',cf19ViewportChange);
  else CF19_MQ.addListener(cf19ViewportChange);

  function boot(){
    SOURCE_FACTS=extractSourceFacts();
    syncPresentationFamily();
    rebuildSourceDescription();
    cf18Sync();
    cf18ObserveSource();
    fillSourcePanels();
    cf19Sync();
    bindBuyNow();
    supportBehavior();
    hideLegacyDuplicateFaq();

    /* Oracle recent behavior: render PREVIOUS history first, then record current PDP.
       Therefore the current product never appears in its own recent rail. */
    renderRecent();
    cfR14bEnhanceRelated();
    recentRecord(currentProductRecord());

    /* COB static Top5 may become READY after DOM boot; sync benefits/NORA context then. */
    window.addEventListener('canfoto:e1-k2-f02a-cob-static-top5-ready',()=>{
      const model=window.CANFOTO_PDP_FIVE_CONTEXT_SHADOW;
      const labels=(model?.selectedSetups||[]).map(x=>textNorm(x?.purposeLabel)).filter(Boolean);
      if(labels.length){
        const benefits=qa('[data-cf85-benefit]');
        benefits.forEach((el,i)=>{
          if(!labels[i]) return;
          el.hidden=false;
          q('b',el).textContent=labels[i];
          q('p',el).textContent='Bu kullanım, ürünün öne çıkan çekim senaryoları arasındadır.';
        });
        r13Render();
      }
    },{once:true});

    window.addEventListener('canfoto:e1-f07b-c1s-panel-static-top5-ready',()=>{
      r13Render();
    },{once:true});

    /* PDP1 lane-parity close: R13's original projection contains the earlier
       51-product C1S pool. The frozen R6 canonical index contains all current
       BARE_LIGHT + SINGLE_READY_SET products (63 total). Re-run the read-only
       renderer when those frozen sources become available so missing single
       ready sets receive their own exact product Top5 context instead of being
       hidden. No donor inference and no live scoring is allowed. */
    ['canfoto:r62he-frozen-index-ready','canfoto:r62he-frozen-panel-snapshot-ready','canfoto:r62he-cob-frozen-top5-ready'].forEach(evt=>{
      window.addEventListener(evt,()=>r13Render(),{once:true});
    });
    [120,400,1000,2200].forEach(ms=>setTimeout(()=>r13Render(),ms));

    let tries=0;
    const timer=setInterval(()=>{
      tries++;
      if(moveMirrorButton()||tries>80) clearInterval(timer);
    },125);

    const ownerState={
      version:VERSION,status:'READY',handle,
      panelPresentationManifestCount:Object.keys(PANEL).length,
      sourceDescriptionMode:q('#urun-aciklamasi .pdp-source-description__body')?.dataset.cfDescriptionMode||(
        q('#urun-aciklamasi .pdp-source-description__body')?.dataset.cf85StructuredSource==='1'?'REV39_STRUCTURED_BODY_HTML':'RAW_FALLBACK'
      ),
      sourceDescriptionOwner:q('#urun-aciklamasi .pdp-source-description__body')?.dataset.cfDescriptionOwner||'RAW_SHOPIFY_DESCRIPTION',
      recentMode:'ORACLE_LOCAL_HISTORY_V1',
      recentHistoryCount:Number(q('[data-cf26-recently-viewed]')?.dataset.cf26HistoryCount||0),
      desktopV18Exact:true,sourceImageModal:'REV85_V18_DESKTOP_SINGLE_OWNER',sourceZoomableCount:qa(`${CF18_SELECTOR}[data-cf18-zoomable=\"true\"]`).length,
      v18BodyFlag:document.body.dataset.canfotoPdpV18==='true',
      v19BodyFlag:document.body.dataset.canfotoPdpV19==='true',
      v27BodyFlag:document.body.dataset.canfotoPdpV27==='true',
      mobileAccordionCount:qa('.cf19-pdp-mobile-acc').length,
      productInfoResponsiveState:q('.pdp-detail-panel.pdp-details-list')?.dataset.cf19ResponsiveInfo||'',
      r9CompactInfoCampaign:window.CANFOTO_E1_F10_R9_PDP_COMPACT_INFO_CAMPAIGN||'',
      r91CommercialCompact:window.CANFOTO_E1_F10_R91_PDP_COMMERCIAL_COMPACT||'',
      r13NoraContextExpansion:window.CANFOTO_E1_F10_R13_NORA_CONTEXT?.status||'FAIL_CLOSED',
      pdp1DecisionCopyPolicy:'SEO_SANITIZE_LOW_QUALITY_TAIL_THEN_BODY_FALLBACK',
      pdp1CanonicalClose:PDP1_CANONICAL_CLOSE,
      pdp1NoraLaneParity:'FROZEN_PRODUCT_TOP5_FALLBACK_FOR_MISSING_BARE_OR_SINGLE',
      pdp2DecisionSentenceGuard:'DECIMAL_SAFE_SENTENCE_BOUNDARY',
      pdp2NoraPanelFullContextParity:'FROZEN_TOP5_PLUS_CANONICAL_PANEL_24_CONTEXT_FOR_MISSING_SINGLE_SET',
      pdp2CobMissingContextPolicy:'TOP5_ONLY_FAIL_CLOSED_NO_INFERENCE',
      pdp3FamilyContextCompatibility:'PANEL_NON_RGB_SUPPRESS_RGB_CREATIVE_CONTEXTS_PRESENTATION_ONLY',
      pdp3CanonicalTop5Mutation:'NONE_SOURCE_TOP5_PRESERVED_EXCEPT_INCOMPATIBLE_VISIBLE_SUPPRESSION',
      pdp4MobileSourceAccordionFit:'MOBILE_ONLY_SHORT_LABEL_PLUS_BOX_SIZING_GUARD',
      buyboxTrustCells:q('[data-canfoto-rev85-trust-row]')?.children.length||0,
      surfaceOwner:'REV85_SINGLE_ACTIVE_PDP_OWNER_F01C',
      semanticOwner:'SHOPIFY_BODY_FACTS_PLUS_EXISTING_COB_METAFIELDS_PLUS_C1S_PANEL_READONLY',
      channelArchitectureAsCri:false,
      roleAsControl:false,
      backInStockOwner:'SHOPIFY_NATIVE_DRAWER_PRESENTATION_TOKENIZED',
      promoPresentationExtras:'DISABLED_BY_PRODUCT_TEMPLATE_R5',
      scoringMutation:'NONE',rankingMutation:'NONE',fpMutation:'NONE',setupTruthMutation:'NONE',
      commerceOwner:'SHOPIFY_NATIVE_SELECTED_VARIANT_AND_CART_ROUTE'
    };
    window.CANFOTO_E1_K2_F01C_REV85_OWNER=ownerState;
    /* Compatibility read alias for earlier non-mutating QA tools. */
    window.CANFOTO_E1_K2_F01B_REV85_EXACT=ownerState;
    document.body.dataset.canfotoPdpOwner='F01C';
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
